import * as No from "vue";
import { ref as gn, inject as _l, shallowRef as kl, computed as dn, watch as Gr, onMounted as Zs, onUnmounted as Cl, defineComponent as wo, h as Js, createVNode as Qs, Text as Ll, Fragment as ea, createElementBlock as fn, openBlock as wn, Transition as Al, withCtx as Tl, createCommentVNode as Ol, unref as mn, createElementVNode as Bn, normalizeClass as xl, toDisplayString as Io } from "vue";
import { getMessaging as Pl, onMessage as Nl, getToken as Il } from "firebase/messaging";
import { initializeApp as Sl } from "firebase/app";
/*! Capacitor: https://capacitorjs.com/ - MIT License */
var zt;
(function(e) {
  e.Unimplemented = "UNIMPLEMENTED", e.Unavailable = "UNAVAILABLE";
})(zt || (zt = {}));
class So extends Error {
  constructor(t, n, o) {
    super(t), this.message = t, this.code = n, this.data = o;
  }
}
const $l = (e) => {
  var t, n;
  return e != null && e.androidBridge ? "android" : !((n = (t = e == null ? void 0 : e.webkit) === null || t === void 0 ? void 0 : t.messageHandlers) === null || n === void 0) && n.bridge ? "ios" : "web";
}, Dl = (e) => {
  const t = e.CapacitorCustomPlatform || null, n = e.Capacitor || {}, o = n.Plugins = n.Plugins || {}, r = () => t !== null ? t.name : $l(e), s = () => r() !== "web", a = (v) => {
    const f = w.get(v);
    return !!(f != null && f.platforms.has(r()) || i(v));
  }, i = (v) => {
    var f;
    return (f = n.PluginHeaders) === null || f === void 0 ? void 0 : f.find((C) => C.name === v);
  }, l = (v) => e.console.error(v), w = /* @__PURE__ */ new Map(), k = (v, f = {}) => {
    const C = w.get(v);
    if (C)
      return console.warn(`Capacitor plugin "${v}" already registered. Cannot register plugins twice.`), C.proxy;
    const P = r(), g = i(v);
    let L;
    const d = async () => (!L && P in f ? L = typeof f[P] == "function" ? L = await f[P]() : L = f[P] : t !== null && !L && "web" in f && (L = typeof f.web == "function" ? L = await f.web() : L = f.web), L), m = (D, B) => {
      var U, H;
      if (g) {
        const z = g == null ? void 0 : g.methods.find((ue) => B === ue.name);
        if (z)
          return z.rtype === "promise" ? (ue) => n.nativePromise(v, B.toString(), ue) : (ue, j) => n.nativeCallback(v, B.toString(), ue, j);
        if (D)
          return (U = D[B]) === null || U === void 0 ? void 0 : U.bind(D);
      } else {
        if (D)
          return (H = D[B]) === null || H === void 0 ? void 0 : H.bind(D);
        throw new So(`"${v}" plugin is not implemented on ${P}`, zt.Unimplemented);
      }
    }, E = (D) => {
      let B;
      const U = (...H) => {
        const z = d().then((ue) => {
          const j = m(ue, D);
          if (j) {
            const I = j(...H);
            return B = I == null ? void 0 : I.remove, I;
          } else
            throw new So(`"${v}.${D}()" is not implemented on ${P}`, zt.Unimplemented);
        });
        return D === "addListener" && (z.remove = async () => B()), z;
      };
      return U.toString = () => `${D.toString()}() { [capacitor code] }`, Object.defineProperty(U, "name", {
        value: D,
        writable: !1,
        configurable: !1
      }), U;
    }, b = E("addListener"), T = E("removeListener"), x = (D, B) => {
      const U = b({ eventName: D }, B), H = async () => {
        const ue = await U;
        T({
          eventName: D,
          callbackId: ue
        }, B);
      }, z = new Promise((ue) => U.then(() => ue({ remove: H })));
      return z.remove = async () => {
        console.warn("Using addListener() without 'await' is deprecated."), await H();
      }, z;
    }, _ = new Proxy({}, {
      get(D, B) {
        switch (B) {
          case "$$typeof":
            return;
          case "toJSON":
            return () => ({});
          case "addListener":
            return g ? x : b;
          case "removeListener":
            return T;
          default:
            return E(B);
        }
      }
    });
    return o[v] = _, w.set(v, {
      name: v,
      proxy: _,
      platforms: /* @__PURE__ */ new Set([...Object.keys(f), ...g ? [P] : []])
    }), _;
  };
  return n.convertFileSrc || (n.convertFileSrc = (v) => v), n.getPlatform = r, n.handleError = l, n.isNativePlatform = s, n.isPluginAvailable = a, n.registerPlugin = k, n.Exception = So, n.DEBUG = !!n.DEBUG, n.isLoggingEnabled = !!n.isLoggingEnabled, n;
}, Ml = (e) => e.Capacitor = Dl(e), bn = /* @__PURE__ */ Ml(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), mo = bn.registerPlugin;
class ir {
  constructor() {
    this.listeners = {}, this.retainedEventArguments = {}, this.windowListeners = {};
  }
  addListener(t, n) {
    let o = !1;
    this.listeners[t] || (this.listeners[t] = [], o = !0), this.listeners[t].push(n);
    const s = this.windowListeners[t];
    s && !s.registered && this.addWindowListener(s), o && this.sendRetainedArgumentsForEvent(t);
    const a = async () => this.removeListener(t, n);
    return Promise.resolve({ remove: a });
  }
  async removeAllListeners() {
    this.listeners = {};
    for (const t in this.windowListeners)
      this.removeWindowListener(this.windowListeners[t]);
    this.windowListeners = {};
  }
  notifyListeners(t, n, o) {
    const r = this.listeners[t];
    if (!r) {
      if (o) {
        let s = this.retainedEventArguments[t];
        s || (s = []), s.push(n), this.retainedEventArguments[t] = s;
      }
      return;
    }
    r.forEach((s) => s(n));
  }
  hasListeners(t) {
    var n;
    return !!(!((n = this.listeners[t]) === null || n === void 0) && n.length);
  }
  registerWindowListener(t, n) {
    this.windowListeners[n] = {
      registered: !1,
      windowEventName: t,
      pluginEventName: n,
      handler: (o) => {
        this.notifyListeners(n, o);
      }
    };
  }
  unimplemented(t = "not implemented") {
    return new bn.Exception(t, zt.Unimplemented);
  }
  unavailable(t = "not available") {
    return new bn.Exception(t, zt.Unavailable);
  }
  async removeListener(t, n) {
    const o = this.listeners[t];
    if (!o)
      return;
    const r = o.indexOf(n);
    this.listeners[t].splice(r, 1), this.listeners[t].length || this.removeWindowListener(this.windowListeners[t]);
  }
  addWindowListener(t) {
    window.addEventListener(t.windowEventName, t.handler), t.registered = !0;
  }
  removeWindowListener(t) {
    t && (window.removeEventListener(t.windowEventName, t.handler), t.registered = !1);
  }
  sendRetainedArgumentsForEvent(t) {
    const n = this.retainedEventArguments[t];
    n && (delete this.retainedEventArguments[t], n.forEach((o) => {
      this.notifyListeners(t, o);
    }));
  }
}
const Xr = (e) => encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), Zr = (e) => e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class Bl extends ir {
  async getCookies() {
    const t = document.cookie, n = {};
    return t.split(";").forEach((o) => {
      if (o.length <= 0)
        return;
      let [r, s] = o.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
      r = Zr(r).trim(), s = Zr(s).trim(), n[r] = s;
    }), n;
  }
  async setCookie(t) {
    try {
      const n = Xr(t.key), o = Xr(t.value), r = `; expires=${(t.expires || "").replace("expires=", "")}`, s = (t.path || "/").replace("path=", ""), a = t.url != null && t.url.length > 0 ? `domain=${t.url}` : "";
      document.cookie = `${n}=${o || ""}${r}; path=${s}; ${a};`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async deleteCookie(t) {
    try {
      document.cookie = `${t.key}=; Max-Age=0`;
    } catch (n) {
      return Promise.reject(n);
    }
  }
  async clearCookies() {
    try {
      const t = document.cookie.split(";") || [];
      for (const n of t)
        document.cookie = n.replace(/^ +/, "").replace(/=.*/, `=;expires=${(/* @__PURE__ */ new Date()).toUTCString()};path=/`);
    } catch (t) {
      return Promise.reject(t);
    }
  }
  async clearAllCookies() {
    try {
      await this.clearCookies();
    } catch (t) {
      return Promise.reject(t);
    }
  }
}
mo("CapacitorCookies", {
  web: () => new Bl()
});
const Rl = async (e) => new Promise((t, n) => {
  const o = new FileReader();
  o.onload = () => {
    const r = o.result;
    t(r.indexOf(",") >= 0 ? r.split(",")[1] : r);
  }, o.onerror = (r) => n(r), o.readAsDataURL(e);
}), Fl = (e = {}) => {
  const t = Object.keys(e);
  return Object.keys(e).map((r) => r.toLocaleLowerCase()).reduce((r, s, a) => (r[s] = e[t[a]], r), {});
}, Ul = (e, t = !0) => e ? Object.entries(e).reduce((o, r) => {
  const [s, a] = r;
  let i, l;
  return Array.isArray(a) ? (l = "", a.forEach((w) => {
    i = t ? encodeURIComponent(w) : w, l += `${s}=${i}&`;
  }), l.slice(0, -1)) : (i = t ? encodeURIComponent(a) : a, l = `${s}=${i}`), `${o}&${l}`;
}, "").substr(1) : null, Vl = (e, t = {}) => {
  const n = Object.assign({ method: e.method || "GET", headers: e.headers }, t), r = Fl(e.headers)["content-type"] || "";
  if (typeof e.data == "string")
    n.body = e.data;
  else if (r.includes("application/x-www-form-urlencoded")) {
    const s = new URLSearchParams();
    for (const [a, i] of Object.entries(e.data || {}))
      s.set(a, i);
    n.body = s.toString();
  } else if (r.includes("multipart/form-data") || e.data instanceof FormData) {
    const s = new FormData();
    if (e.data instanceof FormData)
      e.data.forEach((i, l) => {
        s.append(l, i);
      });
    else
      for (const i of Object.keys(e.data))
        s.append(i, e.data[i]);
    n.body = s;
    const a = new Headers(n.headers);
    a.delete("content-type"), n.headers = a;
  } else (r.includes("application/json") || typeof e.data == "object") && (n.body = JSON.stringify(e.data));
  return n;
};
class Hl extends ir {
  /**
   * Perform an Http request given a set of options
   * @param options Options to build the HTTP request
   */
  async request(t) {
    const n = Vl(t, t.webFetchExtra), o = Ul(t.params, t.shouldEncodeUrlParams), r = o ? `${t.url}?${o}` : t.url, s = await fetch(r, n), a = s.headers.get("content-type") || "";
    let { responseType: i = "text" } = s.ok ? t : {};
    a.includes("application/json") && (i = "json");
    let l, w;
    switch (i) {
      case "arraybuffer":
      case "blob":
        w = await s.blob(), l = await Rl(w);
        break;
      case "json":
        l = await s.json();
        break;
      case "document":
      case "text":
      default:
        l = await s.text();
    }
    const k = {};
    return s.headers.forEach((v, f) => {
      k[f] = v;
    }), {
      data: l,
      headers: k,
      status: s.status,
      url: s.url
    };
  }
  /**
   * Perform an Http GET request given a set of options
   * @param options Options to build the HTTP request
   */
  async get(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "GET" }));
  }
  /**
   * Perform an Http POST request given a set of options
   * @param options Options to build the HTTP request
   */
  async post(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "POST" }));
  }
  /**
   * Perform an Http PUT request given a set of options
   * @param options Options to build the HTTP request
   */
  async put(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PUT" }));
  }
  /**
   * Perform an Http PATCH request given a set of options
   * @param options Options to build the HTTP request
   */
  async patch(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PATCH" }));
  }
  /**
   * Perform an Http DELETE request given a set of options
   * @param options Options to build the HTTP request
   */
  async delete(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "DELETE" }));
  }
}
mo("CapacitorHttp", {
  web: () => new Hl()
});
var Jr;
(function(e) {
  e.Dark = "DARK", e.Light = "LIGHT", e.Default = "DEFAULT";
})(Jr || (Jr = {}));
var Qr;
(function(e) {
  e.StatusBar = "StatusBar", e.NavigationBar = "NavigationBar";
})(Qr || (Qr = {}));
class jl extends ir {
  async setStyle() {
    this.unavailable("not available for web");
  }
  async setAnimation() {
    this.unavailable("not available for web");
  }
  async show() {
    this.unavailable("not available for web");
  }
  async hide() {
    this.unavailable("not available for web");
  }
}
mo("SystemBars", {
  web: () => new jl()
});
const Ot = mo("PushNotifications", {});
/*!
* sweetalert2 v11.26.10
* Released under the MIT License.
*/
function ta(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Wl(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function es(e, t) {
  return e.get(ta(e, t));
}
function Yl(e, t, n) {
  Wl(e, t), t.set(e, n);
}
function ql(e, t, n) {
  return e.set(ta(e, t), n), n;
}
const zl = 100, V = {}, Kl = () => {
  V.previousActiveElement instanceof HTMLElement ? (V.previousActiveElement.focus(), V.previousActiveElement = null) : document.body && document.body.focus();
}, Gl = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  V.restoreFocusTimeout = setTimeout(() => {
    Kl(), t();
  }, zl), window.scrollTo(n, o);
}), na = "swal2-", Xl = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], p = Xl.reduce(
  (e, t) => (e[t] = na + t, e),
  /** @type {SwalClasses} */
  {}
), Zl = ["success", "warning", "info", "question", "error"], Wn = Zl.reduce(
  (e, t) => (e[t] = na + t, e),
  /** @type {SwalIcons} */
  {}
), oa = "SweetAlert2:", lr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Ie = (e) => {
  console.warn(`${oa} ${typeof e == "object" ? e.join(" ") : e}`);
}, Rt = (e) => {
  console.error(`${oa} ${e}`);
}, ts = [], Jl = (e) => {
  ts.includes(e) || (ts.push(e), Ie(e));
}, ra = (e, t = null) => {
  Jl(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, po = (e) => typeof e == "function" ? e() : e, cr = (e) => e && typeof e.toPromise == "function", Cn = (e) => cr(e) ? e.toPromise() : Promise.resolve(e), ur = (e) => e && Promise.resolve(e) === e, $e = () => document.body.querySelector(`.${p.container}`), Ln = (e) => {
  const t = $e();
  return t ? t.querySelector(e) : null;
}, He = (e) => Ln(`.${e}`), J = () => He(p.popup), Qt = () => He(p.icon), Ql = () => He(p["icon-content"]), sa = () => He(p.title), dr = () => He(p["html-container"]), aa = () => He(p.image), fr = () => He(p["progress-steps"]), ho = () => He(p["validation-message"]), it = () => (
  /** @type {HTMLButtonElement} */
  Ln(`.${p.actions} .${p.confirm}`)
), en = () => (
  /** @type {HTMLButtonElement} */
  Ln(`.${p.actions} .${p.cancel}`)
), Ft = () => (
  /** @type {HTMLButtonElement} */
  Ln(`.${p.actions} .${p.deny}`)
), ec = () => He(p["input-label"]), tn = () => Ln(`.${p.loader}`), An = () => He(p.actions), ia = () => He(p.footer), go = () => He(p["timer-progress-bar"]), wr = () => He(p.close), tc = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, mr = () => {
  const e = J();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(tc), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => Be(s));
}, pr = () => mt(document.body, p.shown) && !mt(document.body, p["toast-shown"]) && !mt(document.body, p["no-backdrop"]), bo = () => {
  const e = J();
  return e ? mt(e, p.toast) : !1;
}, nc = () => {
  const e = J();
  return e ? e.hasAttribute("data-loading") : !1;
}, je = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), r = o.querySelector("head");
    r && Array.from(r.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const s = o.querySelector("body");
    s && Array.from(s.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, mt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, oc = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(p).includes(n) && !Object.values(Wn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, Ue = (e, t, n) => {
  if (oc(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Ie(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    ee(e, o);
  }
}, vo = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${p.popup} > .${p[t]}`);
    case "checkbox":
      return e.querySelector(`.${p.popup} > .${p.checkbox} input`);
    case "radio":
      return e.querySelector(`.${p.popup} > .${p.radio} input:checked`) || e.querySelector(`.${p.popup} > .${p.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${p.popup} > .${p.range} input`);
    default:
      return e.querySelector(`.${p.popup} > .${p.input}`);
  }
}, la = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, ca = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, ee = (e, t) => {
  ca(e, t, !0);
}, Ke = (e, t) => {
  ca(e, t, !1);
}, bt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && mt(r, t))
      return r;
  }
}, It = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : n) : e.style.removeProperty(t);
}, ke = (e, t = "flex") => {
  e && (e.style.display = t);
}, xe = (e) => {
  e && (e.style.display = "none");
}, hr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Tn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, ns = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Tn = (e, t, n = "flex") => {
  t ? ke(e, n) : xe(e);
}, Be = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), rc = () => !Be(it()) && !Be(Ft()) && !Be(en()), jo = (e) => e.scrollHeight > e.clientHeight, sc = (e, t) => {
  let n = e;
  for (; n && n !== t; ) {
    if (jo(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, ua = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, gr = (e, t = !1) => {
  const n = go();
  n && Be(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, ac = () => {
  const e = go();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, ic = () => typeof window > "u" || typeof document > "u", lc = `
 <div aria-labelledby="${p.title}" aria-describedby="${p["html-container"]}" class="${p.popup}" tabindex="-1">
   <button type="button" class="${p.close}"></button>
   <ul class="${p["progress-steps"]}"></ul>
   <div class="${p.icon}"></div>
   <img class="${p.image}" />
   <h2 class="${p.title}" id="${p.title}"></h2>
   <div class="${p["html-container"]}" id="${p["html-container"]}"></div>
   <input class="${p.input}" id="${p.input}" />
   <input type="file" class="${p.file}" />
   <div class="${p.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${p.select}" id="${p.select}"></select>
   <div class="${p.radio}"></div>
   <label class="${p.checkbox}">
     <input type="checkbox" id="${p.checkbox}" />
     <span class="${p.label}"></span>
   </label>
   <textarea class="${p.textarea}" id="${p.textarea}"></textarea>
   <div class="${p["validation-message"]}" id="${p["validation-message"]}"></div>
   <div class="${p.actions}">
     <div class="${p.loader}"></div>
     <button type="button" class="${p.confirm}"></button>
     <button type="button" class="${p.deny}"></button>
     <button type="button" class="${p.cancel}"></button>
   </div>
   <div class="${p.footer}"></div>
   <div class="${p["timer-progress-bar-container"]}">
     <div class="${p["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), cc = () => {
  const e = $e();
  return e ? (e.remove(), Ke([document.documentElement, document.body], [p["no-backdrop"], p["toast-shown"], p["has-column"]]), !0) : !1;
}, xt = () => {
  V.currentInstance.resetValidationMessage();
}, uc = () => {
  const e = J(), t = bt(e, p.input), n = bt(e, p.file), o = e.querySelector(`.${p.range} input`), r = e.querySelector(`.${p.range} output`), s = bt(e, p.select), a = e.querySelector(`.${p.checkbox} input`), i = bt(e, p.textarea);
  t.oninput = xt, n.onchange = xt, s.onchange = xt, a.onchange = xt, i.oninput = xt, o.oninput = () => {
    xt(), r.value = o.value;
  }, o.onchange = () => {
    xt(), r.value = o.value;
  };
}, dc = (e) => typeof e == "string" ? document.querySelector(e) : e, fc = (e) => {
  const t = J();
  t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
}, wc = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (ee($e(), p.rtl), V.isRTL = !0);
}, mc = (e) => {
  const t = cc();
  if (ic()) {
    Rt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = p.container, t && ee(n, p["no-transition"]), je(n, lc), n.dataset.swal2Theme = e.theme;
  const o = dc(e.target);
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), fc(e), wc(o), uc();
}, br = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? pc(e, t) : e && je(t, e);
}, pc = (e, t) => {
  e.jquery ? hc(t, e) : je(t, e.toString());
}, hc = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, gc = (e, t) => {
  const n = An(), o = tn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? xe(n) : ke(n), Ue(n, t, "actions"), bc(n, o, t), je(o, t.loaderHtml || ""), Ue(o, t, "loader"));
};
function bc(e, t, n) {
  const o = it(), r = Ft(), s = en();
  !o || !r || !s || (Do(o, "confirm", n), Do(r, "deny", n), Do(s, "cancel", n), vc(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function vc(e, t, n, o) {
  if (!o.buttonsStyling) {
    Ke([e, t, n], p.styled);
    return;
  }
  ee([e, t, n], p.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), $o(e), $o(t), $o(n);
}
function $o(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Do(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    lr(t)
  );
  Tn(e, n[`show${o}Button`], "inline-block"), je(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = p[t], Ue(e, n, `${t}Button`);
}
const yc = (e, t) => {
  const n = wr();
  n && (je(n, t.closeButtonHtml || ""), Ue(n, t, "closeButton"), Tn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Ec = (e, t) => {
  const n = $e();
  n && (_c(n, t.backdrop), kc(n, t.position), Cc(n, t.grow), Ue(n, t, "container"));
};
function _c(e, t) {
  typeof t == "string" ? e.style.background = t : t || ee([document.documentElement, document.body], p["no-backdrop"]);
}
function kc(e, t) {
  t && (t in p ? ee(e, p[t]) : (Ie('The "position" parameter is not valid, defaulting to "center"'), ee(e, p.center)));
}
function Cc(e, t) {
  t && ee(e, p[`grow-${t}`]);
}
var re = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Lc = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Ac = (e, t) => {
  const n = J();
  if (!n)
    return;
  const o = re.innerParams.get(e), r = !o || t.input !== o.input;
  Lc.forEach((s) => {
    const a = bt(n, p[s]);
    a && (xc(s, t.inputAttributes), a.className = p[s], r && xe(a));
  }), t.input && (r && Tc(t), Pc(t));
}, Tc = (e) => {
  if (!e.input)
    return;
  if (!we[e.input]) {
    Rt(`Unexpected type of input! Expected ${Object.keys(we).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = da(e.input);
  if (!t)
    return;
  const n = we[e.input](t, e);
  ke(t), e.inputAutoFocus && setTimeout(() => {
    la(n);
  });
}, Oc = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, xc = (e, t) => {
  const n = J();
  if (!n)
    return;
  const o = vo(n, e);
  if (o) {
    Oc(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, Pc = (e) => {
  if (!e.input)
    return;
  const t = da(e.input);
  t && Ue(t, e, "input");
}, vr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, On = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = p["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && ee(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, da = (e) => {
  const t = J();
  if (t)
    return bt(t, p[
      /** @type {SwalClass} */
      e
    ] || p.input);
}, Yn = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : ur(t) || Ie(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, we = {};
we.text = we.email = we.password = we.number = we.tel = we.url = we.search = we.date = we["datetime-local"] = we.time = we.week = we.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => (Yn(e, t.inputValue), On(e, e, t), vr(e, t), e.type = t.input, e);
we.file = (e, t) => (On(e, e, t), vr(e, t), e);
we.range = (e, t) => {
  const n = e.querySelector("input"), o = e.querySelector("output");
  return Yn(n, t.inputValue), n.type = t.input, Yn(o, t.inputValue), On(n, e, t), e;
};
we.select = (e, t) => {
  if (e.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    je(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
  }
  return On(e, e, t), e;
};
we.radio = (e) => (e.textContent = "", e);
we.checkbox = (e, t) => {
  const n = vo(J(), "checkbox");
  n.value = "1", n.checked = !!t.inputValue;
  const o = e.querySelector("span");
  return je(o, t.inputPlaceholder || t.inputLabel), n;
};
we.textarea = (e, t) => {
  Yn(e, t.inputValue), vr(e, t), On(e, e, t);
  const n = (o) => parseInt(window.getComputedStyle(o).marginLeft) + parseInt(window.getComputedStyle(o).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const o = parseInt(window.getComputedStyle(J()).width), r = () => {
        if (!document.body.contains(e))
          return;
        const s = e.offsetWidth + n(e);
        s > o ? J().style.width = `${s}px` : It(J(), "width", t.width);
      };
      new MutationObserver(r).observe(e, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), e;
};
const Nc = (e, t) => {
  const n = dr();
  n && (hr(n), Ue(n, t, "htmlContainer"), t.html ? (br(t.html, n), ke(n, "block")) : t.text ? (n.textContent = t.text, ke(n, "block")) : xe(n), Ac(e, t));
}, Ic = (e, t) => {
  const n = ia();
  n && (hr(n), Tn(n, !!t.footer, "block"), t.footer && br(t.footer, n), Ue(n, t, "footer"));
}, Sc = (e, t) => {
  const n = re.innerParams.get(e), o = Qt();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    rs(o, t), os(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    xe(o);
    return;
  }
  if (t.icon && Object.keys(Wn).indexOf(t.icon) === -1) {
    Rt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), xe(o);
    return;
  }
  ke(o), rs(o, t), os(o, t), ee(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", fa);
}, os = (e, t) => {
  for (const [n, o] of Object.entries(Wn))
    t.icon !== n && Ke(e, o);
  ee(e, t.icon && Wn[t.icon]), Mc(e, t), fa(), Ue(e, t, "icon");
}, fa = () => {
  const e = J();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, $c = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Dc = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, rs = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = ss(t.iconHtml) : t.icon === "success" ? (o = $c(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = Dc : t.icon && (o = ss({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && je(e, o);
}, Mc = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      ns(e, n, "background-color", t.iconColor);
    ns(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, ss = (e) => `<div class="${p["icon-content"]}">${e}</div>`, Bc = (e, t) => {
  const n = aa();
  if (n) {
    if (!t.imageUrl) {
      xe(n);
      return;
    }
    ke(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), It(n, "width", t.imageWidth), It(n, "height", t.imageHeight), n.className = p.image, Ue(n, t, "image");
  }
};
let yr = !1, wa = 0, ma = 0, pa = 0, ha = 0;
const Rc = (e) => {
  e.addEventListener("mousedown", qn), document.body.addEventListener("mousemove", zn), e.addEventListener("mouseup", Kn), e.addEventListener("touchstart", qn), document.body.addEventListener("touchmove", zn), e.addEventListener("touchend", Kn);
}, Fc = (e) => {
  e.removeEventListener("mousedown", qn), document.body.removeEventListener("mousemove", zn), e.removeEventListener("mouseup", Kn), e.removeEventListener("touchstart", qn), document.body.removeEventListener("touchmove", zn), e.removeEventListener("touchend", Kn);
}, qn = (e) => {
  const t = J();
  if (e.target === t || Qt().contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    yr = !0;
    const n = ga(e);
    wa = n.clientX, ma = n.clientY, pa = parseInt(t.style.insetInlineStart) || 0, ha = parseInt(t.style.insetBlockStart) || 0, ee(t, "swal2-dragging");
  }
}, zn = (e) => {
  const t = J();
  if (yr) {
    let {
      clientX: n,
      clientY: o
    } = ga(e);
    const r = n - wa;
    t.style.insetInlineStart = `${pa + (V.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${ha + (o - ma)}px`;
  }
}, Kn = () => {
  const e = J();
  yr = !1, Ke(e, "swal2-dragging");
}, ga = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, Uc = (e, t) => {
  const n = $e(), o = J();
  if (!(!n || !o)) {
    if (t.toast) {
      It(n, "width", t.width), o.style.width = "100%";
      const r = tn();
      r && o.insertBefore(r, Qt());
    } else
      It(o, "width", t.width);
    It(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), xe(ho()), Vc(o, t), t.draggable && !t.toast ? (ee(o, p.draggable), Rc(o)) : (Ke(o, p.draggable), Fc(o));
  }
}, Vc = (e, t) => {
  const n = t.showClass || {};
  e.className = `${p.popup} ${Be(e) ? n.popup : ""}`, t.toast ? (ee([document.documentElement, document.body], p["toast-shown"]), ee(e, p.toast)) : ee(e, p.modal), Ue(e, t, "popup"), typeof t.customClass == "string" && ee(e, t.customClass), t.icon && ee(e, p[`icon-${t.icon}`]);
}, Hc = (e, t) => {
  const n = fr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    xe(n);
    return;
  }
  ke(n), n.textContent = "", r >= o.length && Ie("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = jc(s);
    if (n.appendChild(i), a === r && ee(i, p["active-progress-step"]), a !== o.length - 1) {
      const l = Wc(t);
      n.appendChild(l);
    }
  });
}, jc = (e) => {
  const t = document.createElement("li");
  return ee(t, p["progress-step"]), je(t, e), t;
}, Wc = (e) => {
  const t = document.createElement("li");
  return ee(t, p["progress-step-line"]), e.progressStepsDistance && It(t, "width", e.progressStepsDistance), t;
}, Yc = (e, t) => {
  const n = sa();
  n && (hr(n), Tn(n, !!(t.title || t.titleText), "block"), t.title && br(t.title, n), t.titleText && (n.innerText = t.titleText), Ue(n, t, "title"));
}, ba = (e, t) => {
  Uc(e, t), Ec(e, t), Hc(e, t), Sc(e, t), Bc(e, t), Yc(e, t), yc(e, t), Nc(e, t), gc(e, t), Ic(e, t);
  const n = J();
  typeof t.didRender == "function" && n && t.didRender(n), V.eventEmitter.emit("didRender", n);
}, qc = () => Be(J()), va = () => {
  var e;
  return (e = it()) === null || e === void 0 ? void 0 : e.click();
}, zc = () => {
  var e;
  return (e = Ft()) === null || e === void 0 ? void 0 : e.click();
}, Kc = () => {
  var e;
  return (e = en()) === null || e === void 0 ? void 0 : e.click();
}, nn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), ya = (e) => {
  e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !1);
}, Gc = (e, t, n) => {
  ya(e), t.toast || (e.keydownHandler = (o) => Zc(t, o, n), e.keydownTarget = t.keydownListenerCapture ? window : J(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !0);
}, Wo = (e, t) => {
  var n;
  const o = mr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = J()) === null || n === void 0 || n.focus();
}, Ea = ["ArrowRight", "ArrowDown"], Xc = ["ArrowLeft", "ArrowUp"], Zc = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Jc(t, e) : t.key === "Tab" ? Qc(t) : [...Ea, ...Xc].includes(t.key) ? eu(t.key) : t.key === "Escape" && tu(t, e, n)));
}, Jc = (e, t) => {
  if (!po(t.allowEnterKey))
    return;
  const n = vo(J(), t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    va(), e.preventDefault();
  }
}, Qc = (e) => {
  const t = e.target, n = mr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? Wo(o, -1) : Wo(o, 1), e.stopPropagation(), e.preventDefault();
}, eu = (e) => {
  const t = An(), n = it(), o = Ft(), r = en();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = Ea.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && Be(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, tu = (e, t, n) => {
  e.preventDefault(), po(t.allowEscapeKey) && n(nn.esc);
};
var Kt = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const nu = () => {
  const e = $e();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, _a = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, ka = typeof window < "u" && !!window.GestureEvent, ou = () => {
  if (ka && !mt(document.body, p.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, ee(document.body, p.iosfix), ru();
  }
}, ru = () => {
  const e = $e();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = su(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, su = (e) => {
  const t = e.target, n = $e(), o = dr();
  return !n || !o || au(e) || iu(e) ? !1 : t === n || !jo(n) && t instanceof HTMLElement && !sc(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(jo(o) && // #1944
  o.contains(t));
}, au = (e) => e.touches && e.touches.length && e.touches[0].touchType === "stylus", iu = (e) => e.touches && e.touches.length > 1, lu = () => {
  if (mt(document.body, p.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    Ke(document.body, p.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, cu = () => {
  const e = document.createElement("div");
  e.className = p["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let Wt = null;
const uu = (e) => {
  Wt === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (Wt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${Wt + cu()}px`);
}, du = () => {
  Wt !== null && (document.body.style.paddingRight = `${Wt}px`, Wt = null);
};
function Ca(e, t, n, o) {
  bo() ? as(e, o) : (Gl(n).then(() => as(e, o)), ya(V)), ka ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), pr() && (du(), lu(), _a()), fu();
}
function fu() {
  Ke([document.documentElement, document.body], [p.shown, p["height-auto"], p["no-backdrop"], p["toast-shown"]]);
}
function vt(e) {
  e = mu(e);
  const t = Kt.swalPromiseResolve.get(this), n = wu(this);
  this.isAwaitingPromise ? e.isDismissed || (xn(this), t(e)) : n && t(e);
}
const wu = (e) => {
  const t = J();
  if (!t)
    return !1;
  const n = re.innerParams.get(e);
  if (!n || mt(t, n.hideClass.popup))
    return !1;
  Ke(t, n.showClass.popup), ee(t, n.hideClass.popup);
  const o = $e();
  return Ke(o, n.showClass.backdrop), ee(o, n.hideClass.backdrop), pu(e, t, n), !0;
};
function La(e) {
  const t = Kt.swalPromiseReject.get(this);
  xn(this), t && t(e);
}
const xn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, re.innerParams.get(e) || e._destroy());
}, mu = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), pu = (e, t, n) => {
  var o;
  const r = $e(), s = ua(t);
  typeof n.willClose == "function" && n.willClose(t), (o = V.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s ? hu(e, t, r, n.returnFocus, n.didClose) : Ca(e, r, n.returnFocus, n.didClose);
}, hu = (e, t, n, o, r) => {
  V.swalCloseEventFinishedCallback = Ca.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = V.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(V), delete V.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, as = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = V.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, Gt = (e) => {
  let t = J();
  if (t || new vn(), t = J(), !t)
    return;
  const n = tn();
  bo() ? xe(Qt()) : gu(t, e), ke(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, gu = (e, t) => {
  const n = An(), o = tn();
  !n || !o || (!t && Be(it()) && (t = it()), ke(n), t && (xe(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), ee([e, n], p.loading));
}, bu = (e, t) => {
  t.input === "select" || t.input === "radio" ? ku(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (cr(t.inputValue) || ur(t.inputValue)) && (Gt(it()), Cu(e, t));
}, vu = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return yu(n);
    case "radio":
      return Eu(n);
    case "file":
      return _u(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, yu = (e) => e.checked ? 1 : 0, Eu = (e) => e.checked ? e.value : null, _u = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, ku = (e, t) => {
  const n = J();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Lu(n, Gn(r), t) : t.input === "radio" && Au(n, Gn(r), t);
  };
  cr(t.inputOptions) || ur(t.inputOptions) ? (Gt(it()), Cn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Rt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Cu = (e, t) => {
  const n = e.getInput();
  n && (xe(n), Cn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, ke(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Rt(`Error in inputValue promise: ${o}`), n.value = "", ke(n), n.focus(), e.hideLoading();
  }));
};
function Lu(e, t, n) {
  const o = bt(e, p.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, je(l, a), l.selected = Aa(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((w) => r(l, w[1], w[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function Au(e, t, n) {
  const o = bt(e, p.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), w = document.createElement("label");
    l.type = "radio", l.name = p.radio, l.value = a, Aa(a, n.inputValue) && (l.checked = !0);
    const k = document.createElement("span");
    je(k, i), k.className = p.label, w.appendChild(l), w.appendChild(k), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const Gn = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = Gn(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = Gn(o)), t.push([n, o]);
  }), t;
}, Aa = (e, t) => !!t && t.toString() === e.toString(), Tu = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.input ? Ta(e, "confirm") : _r(e, !0);
}, Ou = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Ta(e, "deny") : Er(e, !1);
}, xu = (e, t) => {
  e.disableButtons(), t(nn.cancel);
}, Ta = (e, t) => {
  const n = re.innerParams.get(e);
  if (!n.input) {
    Rt(`The "input" parameter is needed to be set when using returnInputValueOn${lr(t)}`);
    return;
  }
  const o = e.getInput(), r = vu(e, n);
  n.inputValidator ? Pu(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Er(e, r) : _r(e, r);
}, Pu = (e, t, n) => {
  const o = re.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Cn(o.inputValidator(t, o.validationMessage))).then((s) => {
    e.enableButtons(), e.enableInput(), s ? e.showValidationMessage(s) : n === "deny" ? Er(e, t) : _r(e, t);
  });
}, Er = (e, t) => {
  const n = re.innerParams.get(e || void 0);
  n.showLoaderOnDeny && Gt(Ft()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Cn(n.preDeny(t, n.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), xn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => Oa(e || void 0, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, is = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Oa = (e, t) => {
  e.rejectPromise(t);
}, _r = (e, t) => {
  const n = re.innerParams.get(e || void 0);
  n.showLoaderOnConfirm && Gt(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Cn(n.preConfirm(t, n.validationMessage))).then((r) => {
    Be(ho()) || r === !1 ? (e.hideLoading(), xn(e)) : is(e, typeof r > "u" ? t : r);
  }).catch((r) => Oa(e || void 0, r))) : is(e, t);
};
function Xn() {
  const e = re.innerParams.get(this);
  if (!e)
    return;
  const t = re.domCache.get(this);
  xe(t.loader), bo() ? e.icon && ke(Qt()) : Nu(t), Ke([t.popup, t.actions], p.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Nu = (e) => {
  const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
  t.length ? ke(t[0], "inline-block") : rc() && xe(e.actions);
};
function xa() {
  const e = re.innerParams.get(this), t = re.domCache.get(this);
  return t ? vo(t.popup, e.input) : null;
}
function Pa(e, t, n) {
  const o = re.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function Na(e, t) {
  const n = J();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${p.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function Ia() {
  Pa(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function Sa() {
  Pa(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function $a() {
  Na(this.getInput(), !1);
}
function Da() {
  Na(this.getInput(), !0);
}
function Ma(e) {
  const t = re.domCache.get(this), n = re.innerParams.get(this);
  je(t.validationMessage, e), t.validationMessage.className = p["validation-message"], n.customClass && n.customClass.validationMessage && ee(t.validationMessage, n.customClass.validationMessage), ke(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", p["validation-message"]), la(o), ee(o, p.inputerror));
}
function Ba() {
  const e = re.domCache.get(this);
  e.validationMessage && xe(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), Ke(t, p.inputerror));
}
const Yt = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Iu = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Su = {
  allowEnterKey: void 0
}, $u = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Ra = (e) => Object.prototype.hasOwnProperty.call(Yt, e), Fa = (e) => Iu.indexOf(e) !== -1, Ua = (e) => Su[e], Du = (e) => {
  Ra(e) || Ie(`Unknown parameter "${e}"`);
}, Mu = (e) => {
  $u.includes(e) && Ie(`The parameter "${e}" is incompatible with toasts`);
}, Bu = (e) => {
  const t = Ua(e);
  t && ra(e, t);
}, Va = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Ie('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Ie(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Du(t), e.toast && Mu(t), Bu(t);
};
function Ha(e) {
  const t = $e(), n = J(), o = re.innerParams.get(this);
  if (!n || mt(n, o.hideClass.popup)) {
    Ie("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = Ru(e), s = Object.assign({}, o, r);
  Va(s), t.dataset.swal2Theme = s.theme, ba(this, s), re.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Ru = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    Fa(n) ? t[n] = e[n] : Ie(`Invalid parameter to update: ${n}`);
  }), t;
};
function ja() {
  const e = re.domCache.get(this), t = re.innerParams.get(this);
  if (!t) {
    Wa(this);
    return;
  }
  e.popup && V.swalCloseEventFinishedCallback && (V.swalCloseEventFinishedCallback(), delete V.swalCloseEventFinishedCallback), typeof t.didDestroy == "function" && t.didDestroy(), V.eventEmitter.emit("didDestroy"), Fu(this);
}
const Fu = (e) => {
  Wa(e), delete e.params, delete V.keydownHandler, delete V.keydownTarget, delete V.currentInstance;
}, Wa = (e) => {
  e.isAwaitingPromise ? (Mo(re, e), e.isAwaitingPromise = !0) : (Mo(Kt, e), Mo(re, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Mo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var Uu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: ja,
  close: vt,
  closeModal: vt,
  closePopup: vt,
  closeToast: vt,
  disableButtons: Sa,
  disableInput: Da,
  disableLoading: Xn,
  enableButtons: Ia,
  enableInput: $a,
  getInput: xa,
  handleAwaitingPromise: xn,
  hideLoading: Xn,
  rejectPromise: La,
  resetValidationMessage: Ba,
  showValidationMessage: Ma,
  update: Ha
});
const Vu = (e, t, n) => {
  e.toast ? Hu(e, t, n) : (Wu(t), Yu(t), qu(e, t, n));
}, Hu = (e, t, n) => {
  t.popup.onclick = () => {
    e && (ju(e) || e.timer || e.input) || n(nn.close);
  };
}, ju = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let Zn = !1;
const Wu = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (Zn = !0);
    };
  };
}, Yu = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (Zn = !0);
    };
  };
}, qu = (e, t, n) => {
  t.container.onclick = (o) => {
    if (Zn) {
      Zn = !1;
      return;
    }
    o.target === t.container && po(e.allowOutsideClick) && n(nn.backdrop);
  };
}, zu = (e) => typeof e == "object" && e.jquery, ls = (e) => e instanceof Element || zu(e), Ku = (e) => {
  const t = {};
  return typeof e[0] == "object" && !ls(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || ls(r) ? t[n] = r : r !== void 0 && Rt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Gu(...e) {
  return new this(...e);
}
function Xu(e) {
  class t extends this {
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const Zu = () => V.timeout && V.timeout.getTimerLeft(), Ya = () => {
  if (V.timeout)
    return ac(), V.timeout.stop();
}, qa = () => {
  if (V.timeout) {
    const e = V.timeout.start();
    return gr(e), e;
  }
}, Ju = () => {
  const e = V.timeout;
  return e && (e.running ? Ya() : qa());
}, Qu = (e) => {
  if (V.timeout) {
    const t = V.timeout.increase(e);
    return gr(t, !0), t;
  }
}, ed = () => !!(V.timeout && V.timeout.isRunning());
let cs = !1;
const Yo = {};
function td(e = "data-swal-template") {
  Yo[e] = this, cs || (document.body.addEventListener("click", nd), cs = !0);
}
const nd = (e) => {
  for (let t = e.target; t && t !== document; t = t.parentNode)
    for (const n in Yo) {
      const o = t.getAttribute(n);
      if (o) {
        Yo[n].fire({
          template: o
        });
        return;
      }
    }
};
class od {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {Array} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
V.eventEmitter = new od();
const rd = (e, t) => {
  V.eventEmitter.on(e, t);
}, sd = (e, t) => {
  V.eventEmitter.once(e, t);
}, ad = (e, t) => {
  if (!e) {
    V.eventEmitter.reset();
    return;
  }
  t ? V.eventEmitter.removeListener(e, t) : V.eventEmitter.removeAllListeners(e);
};
var id = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Ku,
  bindClickHandler: td,
  clickCancel: Kc,
  clickConfirm: va,
  clickDeny: zc,
  enableLoading: Gt,
  fire: Gu,
  getActions: An,
  getCancelButton: en,
  getCloseButton: wr,
  getConfirmButton: it,
  getContainer: $e,
  getDenyButton: Ft,
  getFocusableElements: mr,
  getFooter: ia,
  getHtmlContainer: dr,
  getIcon: Qt,
  getIconContent: Ql,
  getImage: aa,
  getInputLabel: ec,
  getLoader: tn,
  getPopup: J,
  getProgressSteps: fr,
  getTimerLeft: Zu,
  getTimerProgressBar: go,
  getTitle: sa,
  getValidationMessage: ho,
  increaseTimer: Qu,
  isDeprecatedParameter: Ua,
  isLoading: nc,
  isTimerRunning: ed,
  isUpdatableParameter: Fa,
  isValidParameter: Ra,
  isVisible: qc,
  mixin: Xu,
  off: ad,
  on: rd,
  once: sd,
  resumeTimer: qa,
  showLoading: Gt,
  stopTimer: Ya,
  toggleTimer: Ju
});
class ld {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const za = ["swal-title", "swal-html", "swal-footer"], cd = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return gd(n), Object.assign(ud(n), dd(n), fd(n), wd(n), md(n), pd(n), hd(n, za));
}, ud = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    $t(o, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (typeof Yt[r] == "boolean" ? t[r] = s !== "false" : typeof Yt[r] == "object" ? t[r] = JSON.parse(s) : t[r] = s);
  }), t;
}, dd = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (t[r] = new Function(`return ${s}`)());
  }), t;
}, fd = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    $t(o, ["type", "color", "aria-label"]);
    const r = o.getAttribute("type");
    !r || !["confirm", "cancel", "deny"].includes(r) || (t[`${r}ButtonText`] = o.innerHTML, t[`show${lr(r)}Button`] = !0, o.hasAttribute("color") && (t[`${r}ButtonColor`] = o.getAttribute("color")), o.hasAttribute("aria-label") && (t[`${r}ButtonAriaLabel`] = o.getAttribute("aria-label")));
  }), t;
}, wd = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && ($t(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, md = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && ($t(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, pd = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && ($t(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    $t(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, hd = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && ($t(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, gd = (e) => {
  const t = za.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Ie(`Unrecognized element <${o}>`);
  });
}, $t = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Ie([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Ka = 10, bd = (e) => {
  const t = $e(), n = J();
  typeof e.willOpen == "function" && e.willOpen(n), V.eventEmitter.emit("willOpen", n);
  const r = window.getComputedStyle(document.body).overflowY;
  Ed(t, n, e), setTimeout(() => {
    vd(t, n);
  }, Ka), pr() && (yd(t, e.scrollbarPadding, r), nu()), !bo() && !V.previousActiveElement && (V.previousActiveElement = document.activeElement), typeof e.didOpen == "function" && setTimeout(() => e.didOpen(n)), V.eventEmitter.emit("didOpen", n);
}, Jn = (e) => {
  const t = J();
  if (e.target !== t)
    return;
  const n = $e();
  t.removeEventListener("animationend", Jn), t.removeEventListener("transitionend", Jn), n.style.overflowY = "auto", Ke(n, p["no-transition"]);
}, vd = (e, t) => {
  ua(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Jn), t.addEventListener("transitionend", Jn)) : e.style.overflowY = "auto";
}, yd = (e, t, n) => {
  ou(), t && n !== "hidden" && uu(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Ed = (e, t, n) => {
  ee(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), ke(t, "grid"), setTimeout(() => {
    ee(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Ka)) : ke(t, "grid"), ee([document.documentElement, document.body], p.shown), n.heightAuto && n.backdrop && !n.toast && ee([document.documentElement, document.body], p["height-auto"]);
};
var us = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function _d(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = us.email), e.input === "url" && (e.inputValidator = us.url));
}
function kd(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Ie('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Cd(e) {
  _d(e), e.showLoaderOnConfirm && !e.preConfirm && Ie(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), kd(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), mc(e);
}
let rt;
var Rn = /* @__PURE__ */ new WeakMap();
class ge {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Yl(this, Rn, void 0), typeof window > "u")
      return;
    rt = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, ql(Rn, this, this._main(rt.params));
  }
  _main(t, n = {}) {
    if (Va(Object.assign({}, n, t)), V.currentInstance) {
      const s = Kt.swalPromiseResolve.get(V.currentInstance), {
        isAwaitingPromise: a
      } = V.currentInstance;
      V.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), pr() && _a();
    }
    V.currentInstance = rt;
    const o = Ad(t, n);
    Cd(o), Object.freeze(o), V.timeout && (V.timeout.stop(), delete V.timeout), clearTimeout(V.restoreFocusTimeout);
    const r = Td(rt);
    return ba(rt, o), re.innerParams.set(rt, o), Ld(rt, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  then(t) {
    return es(Rn, this).then(t);
  }
  finally(t) {
    return es(Rn, this).finally(t);
  }
}
const Ld = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Kt.swalPromiseResolve.set(e, o), Kt.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    Tu(e);
  }, t.denyButton.onclick = () => {
    Ou(e);
  }, t.cancelButton.onclick = () => {
    xu(e, s);
  }, t.closeButton.onclick = () => {
    s(nn.close);
  }, Vu(n, t, s), Gc(V, n, s), bu(e, n), bd(n), Od(V, n, s), xd(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Ad = (e, t) => {
  const n = cd(e), o = Object.assign({}, Yt, t, n, e);
  return o.showClass = Object.assign({}, Yt.showClass, o.showClass), o.hideClass = Object.assign({}, Yt.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Td = (e) => {
  const t = {
    popup: J(),
    container: $e(),
    actions: An(),
    confirmButton: it(),
    denyButton: Ft(),
    cancelButton: en(),
    loader: tn(),
    closeButton: wr(),
    validationMessage: ho(),
    progressSteps: fr()
  };
  return re.domCache.set(e, t), t;
}, Od = (e, t, n) => {
  const o = go();
  xe(o), t.timer && (e.timeout = new ld(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && (ke(o), Ue(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && gr(t.timer);
  })));
}, xd = (e, t) => {
  if (!t.toast) {
    if (!po(t.allowEnterKey)) {
      ra("allowEnterKey"), Id();
      return;
    }
    Pd(e) || Nd(e, t) || Wo(-1, 1);
  }
}, Pd = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && Be(n))
      return n.focus(), !0;
  return !1;
}, Nd = (e, t) => t.focusDeny && Be(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && Be(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && Be(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Id = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
ge.prototype.disableButtons = Sa;
ge.prototype.enableButtons = Ia;
ge.prototype.getInput = xa;
ge.prototype.disableInput = Da;
ge.prototype.enableInput = $a;
ge.prototype.hideLoading = Xn;
ge.prototype.disableLoading = Xn;
ge.prototype.showValidationMessage = Ma;
ge.prototype.resetValidationMessage = Ba;
ge.prototype.close = vt;
ge.prototype.closePopup = vt;
ge.prototype.closeModal = vt;
ge.prototype.closeToast = vt;
ge.prototype.rejectPromise = La;
ge.prototype.update = Ha;
ge.prototype._destroy = ja;
Object.assign(ge, id);
Object.keys(Uu).forEach((e) => {
  ge[e] = function(...t) {
    return rt && rt[e] ? rt[e](...t) : null;
  };
});
ge.DismissReason = nn;
ge.version = "11.26.10";
const vn = ge;
vn.default = vn;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
var kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ga = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = 1e3, o = 6e4, r = 36e5, s = "millisecond", a = "second", i = "minute", l = "hour", w = "day", k = "week", v = "month", f = "quarter", C = "year", P = "date", g = "Invalid Date", L = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, d = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(j) {
      var I = ["th", "st", "nd", "rd"], N = j % 100;
      return "[" + j + (I[(N - 20) % 10] || I[N] || I[0]) + "]";
    } }, E = function(j, I, N) {
      var F = String(j);
      return !F || F.length >= I ? j : "" + Array(I + 1 - F.length).join(N) + j;
    }, b = { s: E, z: function(j) {
      var I = -j.utcOffset(), N = Math.abs(I), F = Math.floor(N / 60), S = N % 60;
      return (I <= 0 ? "+" : "-") + E(F, 2, "0") + ":" + E(S, 2, "0");
    }, m: function j(I, N) {
      if (I.date() < N.date()) return -j(N, I);
      var F = 12 * (N.year() - I.year()) + (N.month() - I.month()), S = I.clone().add(F, v), q = N - S < 0, W = I.clone().add(F + (q ? -1 : 1), v);
      return +(-(F + (N - S) / (q ? S - W : W - S)) || 0);
    }, a: function(j) {
      return j < 0 ? Math.ceil(j) || 0 : Math.floor(j);
    }, p: function(j) {
      return { M: v, y: C, w: k, d: w, D: P, h: l, m: i, s: a, ms: s, Q: f }[j] || String(j || "").toLowerCase().replace(/s$/, "");
    }, u: function(j) {
      return j === void 0;
    } }, T = "en", x = {};
    x[T] = m;
    var _ = "$isDayjsObject", D = function(j) {
      return j instanceof z || !(!j || !j[_]);
    }, B = function j(I, N, F) {
      var S;
      if (!I) return T;
      if (typeof I == "string") {
        var q = I.toLowerCase();
        x[q] && (S = q), N && (x[q] = N, S = q);
        var W = I.split("-");
        if (!S && W.length > 1) return j(W[0]);
      } else {
        var K = I.name;
        x[K] = I, S = K;
      }
      return !F && S && (T = S), S || !F && T;
    }, U = function(j, I) {
      if (D(j)) return j.clone();
      var N = typeof I == "object" ? I : {};
      return N.date = j, N.args = arguments, new z(N);
    }, H = b;
    H.l = B, H.i = D, H.w = function(j, I) {
      return U(j, { locale: I.$L, utc: I.$u, x: I.$x, $offset: I.$offset });
    };
    var z = function() {
      function j(N) {
        this.$L = B(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[_] = !0;
      }
      var I = j.prototype;
      return I.parse = function(N) {
        this.$d = function(F) {
          var S = F.date, q = F.utc;
          if (S === null) return /* @__PURE__ */ new Date(NaN);
          if (H.u(S)) return /* @__PURE__ */ new Date();
          if (S instanceof Date) return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var W = S.match(L);
            if (W) {
              var K = W[2] - 1 || 0, ae = (W[7] || "0").substring(0, 3);
              return q ? new Date(Date.UTC(W[1], K, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ae)) : new Date(W[1], K, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ae);
            }
          }
          return new Date(S);
        }(N), this.init();
      }, I.init = function() {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, I.$utils = function() {
        return H;
      }, I.isValid = function() {
        return this.$d.toString() !== g;
      }, I.isSame = function(N, F) {
        var S = U(N);
        return this.startOf(F) <= S && S <= this.endOf(F);
      }, I.isAfter = function(N, F) {
        return U(N) < this.startOf(F);
      }, I.isBefore = function(N, F) {
        return this.endOf(F) < U(N);
      }, I.$g = function(N, F, S) {
        return H.u(N) ? this[F] : this.set(S, N);
      }, I.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, I.valueOf = function() {
        return this.$d.getTime();
      }, I.startOf = function(N, F) {
        var S = this, q = !!H.u(F) || F, W = H.p(N), K = function(Ze, ye) {
          var qe = H.w(S.$u ? Date.UTC(S.$y, ye, Ze) : new Date(S.$y, ye, Ze), S);
          return q ? qe : qe.endOf(w);
        }, ae = function(Ze, ye) {
          return H.w(S.toDate()[Ze].apply(S.toDate("s"), (q ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ye)), S);
        }, ce = this.$W, ve = this.$M, Ae = this.$D, ut = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case C:
            return q ? K(1, 0) : K(31, 11);
          case v:
            return q ? K(1, ve) : K(0, ve + 1);
          case k:
            var Xe = this.$locale().weekStart || 0, et = (ce < Xe ? ce + 7 : ce) - Xe;
            return K(q ? Ae - et : Ae + (6 - et), ve);
          case w:
          case P:
            return ae(ut + "Hours", 0);
          case l:
            return ae(ut + "Minutes", 1);
          case i:
            return ae(ut + "Seconds", 2);
          case a:
            return ae(ut + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, I.endOf = function(N) {
        return this.startOf(N, !1);
      }, I.$set = function(N, F) {
        var S, q = H.p(N), W = "set" + (this.$u ? "UTC" : ""), K = (S = {}, S[w] = W + "Date", S[P] = W + "Date", S[v] = W + "Month", S[C] = W + "FullYear", S[l] = W + "Hours", S[i] = W + "Minutes", S[a] = W + "Seconds", S[s] = W + "Milliseconds", S)[q], ae = q === w ? this.$D + (F - this.$W) : F;
        if (q === v || q === C) {
          var ce = this.clone().set(P, 1);
          ce.$d[K](ae), ce.init(), this.$d = ce.set(P, Math.min(this.$D, ce.daysInMonth())).$d;
        } else K && this.$d[K](ae);
        return this.init(), this;
      }, I.set = function(N, F) {
        return this.clone().$set(N, F);
      }, I.get = function(N) {
        return this[H.p(N)]();
      }, I.add = function(N, F) {
        var S, q = this;
        N = Number(N);
        var W = H.p(F), K = function(ve) {
          var Ae = U(q);
          return H.w(Ae.date(Ae.date() + Math.round(ve * N)), q);
        };
        if (W === v) return this.set(v, this.$M + N);
        if (W === C) return this.set(C, this.$y + N);
        if (W === w) return K(1);
        if (W === k) return K(7);
        var ae = (S = {}, S[i] = o, S[l] = r, S[a] = n, S)[W] || 1, ce = this.$d.getTime() + N * ae;
        return H.w(ce, this);
      }, I.subtract = function(N, F) {
        return this.add(-1 * N, F);
      }, I.format = function(N) {
        var F = this, S = this.$locale();
        if (!this.isValid()) return S.invalidDate || g;
        var q = N || "YYYY-MM-DDTHH:mm:ssZ", W = H.z(this), K = this.$H, ae = this.$m, ce = this.$M, ve = S.weekdays, Ae = S.months, ut = S.meridiem, Xe = function(ye, qe, dt, tt) {
          return ye && (ye[qe] || ye(F, q)) || dt[qe].slice(0, tt);
        }, et = function(ye) {
          return H.s(K % 12 || 12, ye, "0");
        }, Ze = ut || function(ye, qe, dt) {
          var tt = ye < 12 ? "AM" : "PM";
          return dt ? tt.toLowerCase() : tt;
        };
        return q.replace(d, function(ye, qe) {
          return qe || function(dt) {
            switch (dt) {
              case "YY":
                return String(F.$y).slice(-2);
              case "YYYY":
                return H.s(F.$y, 4, "0");
              case "M":
                return ce + 1;
              case "MM":
                return H.s(ce + 1, 2, "0");
              case "MMM":
                return Xe(S.monthsShort, ce, Ae, 3);
              case "MMMM":
                return Xe(Ae, ce);
              case "D":
                return F.$D;
              case "DD":
                return H.s(F.$D, 2, "0");
              case "d":
                return String(F.$W);
              case "dd":
                return Xe(S.weekdaysMin, F.$W, ve, 2);
              case "ddd":
                return Xe(S.weekdaysShort, F.$W, ve, 3);
              case "dddd":
                return ve[F.$W];
              case "H":
                return String(K);
              case "HH":
                return H.s(K, 2, "0");
              case "h":
                return et(1);
              case "hh":
                return et(2);
              case "a":
                return Ze(K, ae, !0);
              case "A":
                return Ze(K, ae, !1);
              case "m":
                return String(ae);
              case "mm":
                return H.s(ae, 2, "0");
              case "s":
                return String(F.$s);
              case "ss":
                return H.s(F.$s, 2, "0");
              case "SSS":
                return H.s(F.$ms, 3, "0");
              case "Z":
                return W;
            }
            return null;
          }(ye) || W.replace(":", "");
        });
      }, I.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, I.diff = function(N, F, S) {
        var q, W = this, K = H.p(F), ae = U(N), ce = (ae.utcOffset() - this.utcOffset()) * o, ve = this - ae, Ae = function() {
          return H.m(W, ae);
        };
        switch (K) {
          case C:
            q = Ae() / 12;
            break;
          case v:
            q = Ae();
            break;
          case f:
            q = Ae() / 3;
            break;
          case k:
            q = (ve - ce) / 6048e5;
            break;
          case w:
            q = (ve - ce) / 864e5;
            break;
          case l:
            q = ve / r;
            break;
          case i:
            q = ve / o;
            break;
          case a:
            q = ve / n;
            break;
          default:
            q = ve;
        }
        return S ? q : H.a(q);
      }, I.daysInMonth = function() {
        return this.endOf(v).$D;
      }, I.$locale = function() {
        return x[this.$L];
      }, I.locale = function(N, F) {
        if (!N) return this.$L;
        var S = this.clone(), q = B(N, F, !0);
        return q && (S.$L = q), S;
      }, I.clone = function() {
        return H.w(this.$d, this);
      }, I.toDate = function() {
        return new Date(this.valueOf());
      }, I.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, I.toISOString = function() {
        return this.$d.toISOString();
      }, I.toString = function() {
        return this.$d.toUTCString();
      }, j;
    }(), ue = z.prototype;
    return U.prototype = ue, [["$ms", s], ["$s", a], ["$m", i], ["$H", l], ["$W", w], ["$M", v], ["$y", C], ["$D", P]].forEach(function(j) {
      ue[j[1]] = function(I) {
        return this.$g(I, j[0], j[1]);
      };
    }), U.extend = function(j, I) {
      return j.$i || (j(I, z, U), j.$i = !0), U;
    }, U.locale = B, U.isDayjs = D, U.unix = function(j) {
      return U(1e3 * j);
    }, U.en = x[T], U.Ls = x, U.p = {}, U;
  });
})(Ga);
var Sd = Ga.exports;
const Xa = /* @__PURE__ */ Cr(Sd);
var Za = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(s, a, i) {
      var l = a.prototype;
      i.utc = function(g) {
        var L = { date: g, utc: !0, args: arguments };
        return new a(L);
      }, l.utc = function(g) {
        var L = i(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? L.add(this.utcOffset(), n) : L;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var w = l.parse;
      l.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), w.call(this, g);
      };
      var k = l.init;
      l.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else k.call(this);
      };
      var v = l.utcOffset;
      l.utcOffset = function(g, L) {
        var d = this.$utils().u;
        if (d(g)) return this.$u ? 0 : d(this.$offset) ? v.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(T) {
          T === void 0 && (T = "");
          var x = T.match(o);
          if (!x) return null;
          var _ = ("" + x[0]).match(r) || ["-", 0, 0], D = _[0], B = 60 * +_[1] + +_[2];
          return B === 0 ? 0 : D === "+" ? B : -B;
        }(g), g === null)) return this;
        var m = Math.abs(g) <= 16 ? 60 * g : g;
        if (m === 0) return this.utc(L);
        var E = this.clone();
        if (L) return E.$offset = m, E.$u = !1, E;
        var b = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (E = this.local().add(m + b, n)).$offset = m, E.$x.$localOffset = b, E;
      };
      var f = l.format;
      l.format = function(g) {
        var L = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return f.call(this, L);
      }, l.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var C = l.toDate;
      l.toDate = function(g) {
        return g === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : C.call(this);
      };
      var P = l.diff;
      l.diff = function(g, L, d) {
        if (g && this.$u === g.$u) return P.call(this, g, L, d);
        var m = this.local(), E = i(g).local();
        return P.call(m, E, L, d);
      };
    };
  });
})(Za);
var $d = Za.exports;
const Dd = /* @__PURE__ */ Cr($d);
var Ja = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, o = {};
    return function(r, s, a) {
      var i, l = function(f, C, P) {
        P === void 0 && (P = {});
        var g = new Date(f), L = function(d, m) {
          m === void 0 && (m = {});
          var E = m.timeZoneName || "short", b = d + "|" + E, T = o[b];
          return T || (T = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: d, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: E }), o[b] = T), T;
        }(C, P);
        return L.formatToParts(g);
      }, w = function(f, C) {
        for (var P = l(f, C), g = [], L = 0; L < P.length; L += 1) {
          var d = P[L], m = d.type, E = d.value, b = n[m];
          b >= 0 && (g[b] = parseInt(E, 10));
        }
        var T = g[3], x = T === 24 ? 0 : T, _ = g[0] + "-" + g[1] + "-" + g[2] + " " + x + ":" + g[4] + ":" + g[5] + ":000", D = +f;
        return (a.utc(_).valueOf() - (D -= D % 1e3)) / 6e4;
      }, k = s.prototype;
      k.tz = function(f, C) {
        f === void 0 && (f = i);
        var P, g = this.utcOffset(), L = this.toDate(), d = L.toLocaleString("en-US", { timeZone: f }), m = Math.round((L - new Date(d)) / 1e3 / 60), E = 15 * -Math.round(L.getTimezoneOffset() / 15) - m;
        if (!Number(E)) P = this.utcOffset(0, C);
        else if (P = a(d, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(E, !0), C) {
          var b = P.utcOffset();
          P = P.add(g - b, "minute");
        }
        return P.$x.$timezone = f, P;
      }, k.offsetName = function(f) {
        var C = this.$x.$timezone || a.tz.guess(), P = l(this.valueOf(), C, { timeZoneName: f }).find(function(g) {
          return g.type.toLowerCase() === "timezonename";
        });
        return P && P.value;
      };
      var v = k.startOf;
      k.startOf = function(f, C) {
        if (!this.$x || !this.$x.$timezone) return v.call(this, f, C);
        var P = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return v.call(P, f, C).tz(this.$x.$timezone, !0);
      }, a.tz = function(f, C, P) {
        var g = P && C, L = P || C || i, d = w(+a(), L);
        if (typeof f != "string") return a(f).tz(L);
        var m = function(x, _, D) {
          var B = x - 60 * _ * 1e3, U = w(B, D);
          if (_ === U) return [B, _];
          var H = w(B -= 60 * (U - _) * 1e3, D);
          return U === H ? [B, U] : [x - 60 * Math.min(U, H) * 1e3, Math.max(U, H)];
        }(a.utc(f, g).valueOf(), d, L), E = m[0], b = m[1], T = a(E).utcOffset(b);
        return T.$x.$timezone = L, T;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(f) {
        i = f;
      };
    };
  });
})(Ja);
var Md = Ja.exports;
const Bd = /* @__PURE__ */ Cr(Md);
Xa.extend(Dd);
Xa.extend(Bd);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function Qa(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Rd(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function ds(e, t) {
  return e.get(Qa(e, t));
}
function Fd(e, t, n) {
  Rd(e, t), t.set(e, n);
}
function Ud(e, t, n) {
  return e.set(Qa(e, t), n), n;
}
const Vd = 100, R = {}, Hd = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, jd = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    Hd(), t();
  }, Vd), window.scrollTo(n, o);
}), ei = "swal2-", Wd = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], h = Wd.reduce(
  (e, t) => (e[t] = ei + t, e),
  /** @type {SwalClasses} */
  {}
), Yd = ["success", "warning", "info", "question", "error"], Qn = Yd.reduce(
  (e, t) => (e[t] = ei + t, e),
  /** @type {SwalIcons} */
  {}
), ti = "SweetAlert2:", Lr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Se = (e) => {
  console.warn(`${ti} ${typeof e == "object" ? e.join(" ") : e}`);
}, Ut = (e) => {
  console.error(`${ti} ${e}`);
}, fs = [], qd = (e) => {
  fs.includes(e) || (fs.push(e), Se(e));
}, ni = (e, t = null) => {
  qd(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, yo = (e) => typeof e == "function" ? e() : e, Ar = (e) => e && typeof e.toPromise == "function", Pn = (e) => Ar(e) ? e.toPromise() : Promise.resolve(e), Tr = (e) => e && Promise.resolve(e) === e, De = () => document.body.querySelector(`.${h.container}`), Nn = (e) => {
  const t = De();
  return t ? t.querySelector(e) : null;
}, We = (e) => Nn(`.${e}`), ne = () => We(h.popup), on = () => We(h.icon), zd = () => We(h["icon-content"]), oi = () => We(h.title), Or = () => We(h["html-container"]), ri = () => We(h.image), xr = () => We(h["progress-steps"]), Eo = () => We(h["validation-message"]), lt = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${h.actions} .${h.confirm}`)
), rn = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${h.actions} .${h.cancel}`)
), Vt = () => (
  /** @type {HTMLButtonElement} */
  Nn(`.${h.actions} .${h.deny}`)
), Kd = () => We(h["input-label"]), sn = () => Nn(`.${h.loader}`), In = () => We(h.actions), si = () => We(h.footer), _o = () => We(h["timer-progress-bar"]), Pr = () => We(h.close), Gd = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Nr = () => {
  const e = ne();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(Gd), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => Re(s));
}, Ir = () => pt(document.body, h.shown) && !pt(document.body, h["toast-shown"]) && !pt(document.body, h["no-backdrop"]), ko = () => {
  const e = ne();
  return e ? pt(e, h.toast) : !1;
}, Xd = () => {
  const e = ne();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ye = (e, t) => {
  if (e.textContent = "", t) {
    const n = new DOMParser().parseFromString(t, "text/html"), o = n.querySelector("head");
    o && Array.from(o.childNodes).forEach((s) => {
      e.appendChild(s);
    });
    const r = n.querySelector("body");
    r && Array.from(r.childNodes).forEach((s) => {
      s instanceof HTMLVideoElement || s instanceof HTMLAudioElement ? e.appendChild(s.cloneNode(!0)) : e.appendChild(s);
    });
  }
}, pt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, Zd = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(h).includes(n) && !Object.values(Qn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, Ve = (e, t, n) => {
  if (Zd(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Se(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    te(e, o);
  }
}, Co = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${h.popup} > .${h[t]}`);
    case "checkbox":
      return e.querySelector(`.${h.popup} > .${h.checkbox} input`);
    case "radio":
      return e.querySelector(`.${h.popup} > .${h.radio} input:checked`) || e.querySelector(`.${h.popup} > .${h.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${h.popup} > .${h.range} input`);
    default:
      return e.querySelector(`.${h.popup} > .${h.input}`);
  }
}, ai = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, ii = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, te = (e, t) => {
  ii(e, t, !0);
}, Ge = (e, t) => {
  ii(e, t, !1);
}, yt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && pt(r, t))
      return r;
  }
}, St = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Ce = (e, t = "flex") => {
  e && (e.style.display = t);
}, Pe = (e) => {
  e && (e.style.display = "none");
}, Sr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Sn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, ws = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Sn = (e, t, n = "flex") => {
  t ? Ce(e, n) : Pe(e);
}, Re = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Jd = () => !Re(lt()) && !Re(Vt()) && !Re(rn()), qo = (e) => e.scrollHeight > e.clientHeight, Qd = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (qo(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, li = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, $r = (e, t = !1) => {
  const n = _o();
  n && Re(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, ef = () => {
  const e = _o();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, tf = () => typeof window > "u" || typeof document > "u", nf = `
 <div aria-labelledby="${h.title}" aria-describedby="${h["html-container"]}" class="${h.popup}" tabindex="-1">
   <button type="button" class="${h.close}"></button>
   <ul class="${h["progress-steps"]}"></ul>
   <div class="${h.icon}"></div>
   <img class="${h.image}" />
   <h2 class="${h.title}" id="${h.title}"></h2>
   <div class="${h["html-container"]}" id="${h["html-container"]}"></div>
   <input class="${h.input}" id="${h.input}" />
   <input type="file" class="${h.file}" />
   <div class="${h.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${h.select}" id="${h.select}"></select>
   <div class="${h.radio}"></div>
   <label class="${h.checkbox}">
     <input type="checkbox" id="${h.checkbox}" />
     <span class="${h.label}"></span>
   </label>
   <textarea class="${h.textarea}" id="${h.textarea}"></textarea>
   <div class="${h["validation-message"]}" id="${h["validation-message"]}"></div>
   <div class="${h.actions}">
     <div class="${h.loader}"></div>
     <button type="button" class="${h.confirm}"></button>
     <button type="button" class="${h.deny}"></button>
     <button type="button" class="${h.cancel}"></button>
   </div>
   <div class="${h.footer}"></div>
   <div class="${h["timer-progress-bar-container"]}">
     <div class="${h["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), of = () => {
  const e = De();
  return e ? (e.remove(), Ge([document.documentElement, document.body], [
    h["no-backdrop"],
    h["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    h["has-column"]
  ]), !0) : !1;
}, Pt = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, rf = () => {
  const e = ne();
  if (!e)
    return;
  const t = yt(e, h.input), n = yt(e, h.file), o = e.querySelector(`.${h.range} input`), r = e.querySelector(`.${h.range} output`), s = yt(e, h.select), a = e.querySelector(`.${h.checkbox} input`), i = yt(e, h.textarea);
  t && (t.oninput = Pt), n && (n.onchange = Pt), s && (s.onchange = Pt), a && (a.onchange = Pt), i && (i.oninput = Pt), o && r && (o.oninput = () => {
    Pt(), r.value = o.value;
  }, o.onchange = () => {
    Pt(), r.value = o.value;
  });
}, sf = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, af = (e) => {
  const t = ne();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, lf = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (te(De(), h.rtl), R.isRTL = !0);
}, cf = (e) => {
  const t = of();
  if (tf()) {
    Ut("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = h.container, t && te(n, h["no-transition"]), Ye(n, nf), n.dataset.swal2Theme = e.theme;
  const o = sf(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), af(e), lf(o), rf();
}, Dr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? uf(e, t) : e && Ye(t, e);
}, uf = (e, t) => {
  "jquery" in e ? df(t, e) : Ye(t, e.toString());
}, df = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, ff = (e, t) => {
  const n = In(), o = sn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Pe(n) : Ce(n), Ve(n, t, "actions"), wf(n, o, t), Ye(o, t.loaderHtml || ""), Ve(o, t, "loader"));
};
function wf(e, t, n) {
  const o = lt(), r = Vt(), s = rn();
  !o || !r || !s || (Ro(o, "confirm", n), Ro(r, "deny", n), Ro(s, "cancel", n), mf(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function mf(e, t, n, o) {
  if (!o.buttonsStyling) {
    Ge([e, t, n], h.styled);
    return;
  }
  te([e, t, n], h.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Bo(e), Bo(t), Bo(n);
}
function Bo(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Ro(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Lr(t)
  );
  Sn(e, n[`show${o}Button`], "inline-block"), Ye(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = h[t], Ve(e, n, `${t}Button`);
}
const pf = (e, t) => {
  const n = Pr();
  n && (Ye(n, t.closeButtonHtml || ""), Ve(n, t, "closeButton"), Sn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, hf = (e, t) => {
  const n = De();
  n && (gf(n, t.backdrop), bf(n, t.position), vf(n, t.grow), Ve(n, t, "container"));
};
function gf(e, t) {
  typeof t == "string" ? e.style.background = t : t || te([document.documentElement, document.body], h["no-backdrop"]);
}
function bf(e, t) {
  t && (t in h ? te(e, h[t]) : (Se('The "position" parameter is not valid, defaulting to "center"'), te(e, h.center)));
}
function vf(e, t) {
  t && te(e, h[`grow-${t}`]);
}
var se = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const yf = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Ef = (e, t) => {
  const n = ne();
  if (!n)
    return;
  const o = se.innerParams.get(e), r = !o || t.input !== o.input;
  yf.forEach((s) => {
    const a = yt(n, h[s]);
    a && (Cf(s, t.inputAttributes), a.className = h[s], r && Pe(a));
  }), t.input && (r && _f(t), Lf(t));
}, _f = (e) => {
  if (!e.input)
    return;
  if (!me[e.input]) {
    Ut(`Unexpected type of input! Expected ${Object.keys(me).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = ci(e.input);
  if (!t)
    return;
  const n = me[e.input](t, e);
  Ce(t), e.inputAutoFocus && setTimeout(() => {
    ai(n);
  });
}, kf = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, Cf = (e, t) => {
  const n = ne();
  if (!n)
    return;
  const o = Co(n, e);
  if (o) {
    kf(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, Lf = (e) => {
  if (!e.input)
    return;
  const t = ci(e.input);
  t && Ve(t, e, "input");
}, Mr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, $n = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = h["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && te(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, ci = (e) => {
  const t = ne();
  if (t)
    return yt(t, h[
      /** @type {SwalClass} */
      e
    ] || h.input);
}, eo = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Tr(t) || Se(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, me = {};
me.text = me.email = me.password = me.number = me.tel = me.url = me.search = me.date = me["datetime-local"] = me.time = me.week = me.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return eo(n, t.inputValue), $n(n, n, t), Mr(n, t), n.type = /** @type {string} */
  t.input, n;
};
me.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return $n(n, n, t), Mr(n, t), n;
};
me.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (eo(o, t.inputValue), o.type = /** @type {string} */
  t.input, $n(
    o,
    /** @type {Input} */
    e,
    t
  )), r && eo(r, t.inputValue), /** @type {Input} */
  e;
};
me.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ye(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return $n(n, n, t), n;
};
me.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
me.checkbox = (e, t) => {
  const n = ne();
  if (!n)
    throw new Error("Popup not found");
  const o = Co(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = (
    /** @type {HTMLElement} */
    e.querySelector("span")
  );
  if (r) {
    const s = t.inputPlaceholder || t.inputLabel;
    s && Ye(r, s);
  }
  return o;
};
me.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  eo(n, t.inputValue), Mr(n, t), $n(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = ne();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), l = ne();
        l && (i > s ? l.style.width = `${i}px` : St(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const Af = (e, t) => {
  const n = Or();
  n && (Sr(n), Ve(n, t, "htmlContainer"), t.html ? (Dr(t.html, n), Ce(n, "block")) : t.text ? (n.textContent = t.text, Ce(n, "block")) : Pe(n), Ef(e, t));
}, Tf = (e, t) => {
  const n = si();
  n && (Sr(n), Sn(n, !!t.footer, "block"), t.footer && Dr(t.footer, n), Ve(n, t, "footer"));
}, Of = (e, t) => {
  const n = se.innerParams.get(e), o = on();
  if (o) {
    if (n && t.icon === n.icon) {
      ps(o, t), ms(o, t);
      return;
    }
    if (!t.icon && !t.iconHtml) {
      Pe(o);
      return;
    }
    if (t.icon && Object.keys(Qn).indexOf(t.icon) === -1) {
      Ut(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Pe(o);
      return;
    }
    Ce(o), ps(o, t), ms(o, t), te(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ui);
  }
}, ms = (e, t) => {
  for (const [n, o] of Object.entries(Qn))
    t.icon !== n && Ge(e, o);
  te(e, t.icon && Qn[t.icon]), Nf(e, t), ui(), Ve(e, t, "icon");
}, ui = () => {
  const e = ne();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, xf = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Pf = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, ps = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = hs(t.iconHtml) : t.icon === "success" ? (o = xf(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = Pf : t.icon && (o = hs({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ye(e, o);
}, Nf = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      ws(e, n, "background-color", t.iconColor);
    ws(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, hs = (e) => `<div class="${h["icon-content"]}">${e}</div>`, If = (e, t) => {
  const n = ri();
  if (n) {
    if (!t.imageUrl) {
      Pe(n);
      return;
    }
    Ce(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), St(n, "width", t.imageWidth), St(n, "height", t.imageHeight), n.className = h.image, Ve(n, t, "image");
  }
};
let Br = !1, di = 0, fi = 0, wi = 0, mi = 0;
const Sf = (e) => {
  e.addEventListener("mousedown", to), document.body.addEventListener("mousemove", no), e.addEventListener("mouseup", oo), e.addEventListener("touchstart", to), document.body.addEventListener("touchmove", no), e.addEventListener("touchend", oo);
}, $f = (e) => {
  e.removeEventListener("mousedown", to), document.body.removeEventListener("mousemove", no), e.removeEventListener("mouseup", oo), e.removeEventListener("touchstart", to), document.body.removeEventListener("touchmove", no), e.removeEventListener("touchend", oo);
}, to = (e) => {
  const t = ne();
  if (!t)
    return;
  const n = on();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Br = !0;
    const o = pi(e);
    di = o.clientX, fi = o.clientY, wi = parseInt(t.style.insetInlineStart) || 0, mi = parseInt(t.style.insetBlockStart) || 0, te(t, "swal2-dragging");
  }
}, no = (e) => {
  const t = ne();
  if (t && Br) {
    let {
      clientX: n,
      clientY: o
    } = pi(e);
    const r = n - di;
    t.style.insetInlineStart = `${wi + (R.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${mi + (o - fi)}px`;
  }
}, oo = () => {
  const e = ne();
  Br = !1, Ge(e, "swal2-dragging");
}, pi = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, Df = (e, t) => {
  const n = De(), o = ne();
  if (!(!n || !o)) {
    if (t.toast) {
      St(n, "width", t.width), o.style.width = "100%";
      const r = sn();
      r && o.insertBefore(r, on());
    } else
      St(o, "width", t.width);
    St(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Pe(Eo()), Mf(o, t), t.draggable && !t.toast ? (te(o, h.draggable), Sf(o)) : (Ge(o, h.draggable), $f(o));
  }
}, Mf = (e, t) => {
  const n = t.showClass || {};
  e.className = `${h.popup} ${Re(e) ? n.popup : ""}`, t.toast ? (te([document.documentElement, document.body], h["toast-shown"]), te(e, h.toast)) : te(e, h.modal), Ve(e, t, "popup"), typeof t.customClass == "string" && te(e, t.customClass), t.icon && te(e, h[`icon-${t.icon}`]);
}, Bf = (e, t) => {
  const n = xr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    Pe(n);
    return;
  }
  Ce(n), n.textContent = "", r >= o.length && Se("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = Rf(s);
    if (n.appendChild(i), a === r && te(i, h["active-progress-step"]), a !== o.length - 1) {
      const l = Ff(t);
      n.appendChild(l);
    }
  });
}, Rf = (e) => {
  const t = document.createElement("li");
  return te(t, h["progress-step"]), Ye(t, e), t;
}, Ff = (e) => {
  const t = document.createElement("li");
  return te(t, h["progress-step-line"]), e.progressStepsDistance && St(t, "width", e.progressStepsDistance), t;
}, Uf = (e, t) => {
  const n = oi();
  n && (Sr(n), Sn(n, !!(t.title || t.titleText), "block"), t.title && Dr(t.title, n), t.titleText && (n.innerText = t.titleText), Ve(n, t, "title"));
}, hi = (e, t) => {
  var n;
  Df(e, t), hf(e, t), Bf(e, t), Of(e, t), If(e, t), Uf(e, t), pf(e, t), Af(e, t), ff(e, t), Tf(e, t);
  const o = ne();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, Vf = () => Re(ne()), gi = () => {
  var e;
  return (e = lt()) === null || e === void 0 ? void 0 : e.click();
}, Hf = () => {
  var e;
  return (e = Vt()) === null || e === void 0 ? void 0 : e.click();
}, jf = () => {
  var e;
  return (e = rn()) === null || e === void 0 ? void 0 : e.click();
}, an = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), bi = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, Wf = (e, t, n) => {
  if (bi(e), !t.toast) {
    const o = (s) => qf(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : ne();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, zo = (e, t) => {
  var n;
  const o = Nr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = ne()) === null || n === void 0 || n.focus();
}, vi = ["ArrowRight", "ArrowDown"], Yf = ["ArrowLeft", "ArrowUp"], qf = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? zf(t, e) : t.key === "Tab" ? Kf(t) : [...vi, ...Yf].includes(t.key) ? Gf(t.key) : t.key === "Escape" && Xf(t, e, n)));
}, zf = (e, t) => {
  if (!yo(t.allowEnterKey))
    return;
  const n = ne();
  if (!n || !t.input)
    return;
  const o = Co(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    gi(), e.preventDefault();
  }
}, Kf = (e) => {
  const t = e.target, n = Nr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? zo(o, -1) : zo(o, 1), e.stopPropagation(), e.preventDefault();
}, Gf = (e) => {
  const t = In(), n = lt(), o = Vt(), r = rn();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = vi.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && Re(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Xf = (e, t, n) => {
  e.preventDefault(), yo(t.allowEscapeKey) && n(an.esc);
};
var Xt = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Zf = () => {
  const e = De();
  Array.from(document.body.children).forEach((t) => {
    t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
  });
}, yi = () => {
  Array.from(document.body.children).forEach((e) => {
    e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
  });
}, Ei = typeof window < "u" && !!window.GestureEvent, Jf = () => {
  if (Ei && !pt(document.body, h.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, te(document.body, h.iosfix), Qf();
  }
}, Qf = () => {
  const e = De();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = ew(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, ew = (e) => {
  const t = e.target, n = De(), o = Or();
  return !n || !o || tw(e) || nw(e) ? !1 : t === n || !qo(n) && t instanceof HTMLElement && !Qd(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(qo(o) && // #1944
  o.contains(t));
}, tw = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), nw = (e) => e.touches && e.touches.length > 1, ow = () => {
  if (pt(document.body, h.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    Ge(document.body, h.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, rw = () => {
  const e = document.createElement("div");
  e.className = h["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let qt = null;
const sw = (e) => {
  qt === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (qt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${qt + rw()}px`);
}, aw = () => {
  qt !== null && (document.body.style.paddingRight = `${qt}px`, qt = null);
};
function _i(e, t, n, o) {
  ko() ? gs(e, o) : (jd(n).then(() => gs(e, o)), bi(R)), Ei ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Ir() && (aw(), ow(), yi()), iw();
}
function iw() {
  Ge([document.documentElement, document.body], [h.shown, h["height-auto"], h["no-backdrop"], h["toast-shown"]]);
}
function Et(e) {
  e = cw(e);
  const t = Xt.swalPromiseResolve.get(this), n = lw(this);
  this.isAwaitingPromise ? e.isDismissed || (Dn(this), t(e)) : n && t(e);
}
const lw = (e) => {
  const t = ne();
  if (!t)
    return !1;
  const n = se.innerParams.get(e);
  if (!n || pt(t, n.hideClass.popup))
    return !1;
  Ge(t, n.showClass.popup), te(t, n.hideClass.popup);
  const o = De();
  return Ge(o, n.showClass.backdrop), te(o, n.hideClass.backdrop), uw(e, t, n), !0;
};
function ki(e) {
  const t = Xt.swalPromiseReject.get(this);
  Dn(this), t && t(e);
}
const Dn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, se.innerParams.get(e) || e._destroy());
}, cw = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), uw = (e, t, n) => {
  var o;
  const r = De(), s = li(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? dw(e, t, r, !!n.returnFocus, n.didClose) : r && _i(e, r, !!n.returnFocus, n.didClose);
}, dw = (e, t, n, o, r) => {
  R.swalCloseEventFinishedCallback = _i.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = R.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, gs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, Zt = (e) => {
  let t = ne();
  if (t || new Go(), t = ne(), !t)
    return;
  const n = sn();
  ko() ? Pe(on()) : fw(t, e), Ce(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, fw = (e, t) => {
  const n = In(), o = sn();
  !n || !o || (!t && Re(lt()) && (t = lt()), Ce(n), t && (Pe(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), te([e, n], h.loading));
}, ww = (e, t) => {
  t.input === "select" || t.input === "radio" ? bw(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Ar(t.inputValue) || Tr(t.inputValue)) && (Zt(lt()), vw(e, t));
}, mw = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return pw(n);
    case "radio":
      return hw(n);
    case "file":
      return gw(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, pw = (e) => e.checked ? 1 : 0, hw = (e) => e.checked ? e.value : null, gw = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, bw = (e, t) => {
  const n = ne();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? yw(n, ro(r), t) : t.input === "radio" && Ew(n, ro(r), t);
  };
  Ar(t.inputOptions) || Tr(t.inputOptions) ? (Zt(lt()), Pn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Ut(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, vw = (e, t) => {
  const n = e.getInput();
  n && (Pe(n), Pn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Ce(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Ut(`Error in inputValue promise: ${o}`), n.value = "", Ce(n), n.focus(), e.hideLoading();
  }));
};
function yw(e, t, n) {
  const o = yt(e, h.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ye(l, a), l.selected = Ci(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((w) => r(l, w[1], w[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function Ew(e, t, n) {
  const o = yt(e, h.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), w = document.createElement("label");
    l.type = "radio", l.name = h.radio, l.value = a, Ci(a, n.inputValue) && (l.checked = !0);
    const k = document.createElement("span");
    Ye(k, i), k.className = h.label, w.appendChild(l), w.appendChild(k), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const ro = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = ro(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = ro(o)), t.push([n, o]);
  }), t;
}, Ci = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), _w = (e) => {
  const t = se.innerParams.get(e);
  e.disableButtons(), t.input ? Li(e, "confirm") : Fr(e, !0);
}, kw = (e) => {
  const t = se.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Li(e, "deny") : Rr(e, !1);
}, Cw = (e, t) => {
  e.disableButtons(), t(an.cancel);
}, Li = (e, t) => {
  const n = se.innerParams.get(e);
  if (!n.input) {
    Ut(`The "input" parameter is needed to be set when using returnInputValueOn${Lr(t)}`);
    return;
  }
  const o = e.getInput(), r = mw(e, n);
  n.inputValidator ? Lw(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Rr(e, r) : Fr(e, r);
}, Lw = (e, t, n) => {
  const o = se.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Pn(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Rr(e, t) : Fr(e, t);
  });
}, Rr = (e, t) => {
  const n = se.innerParams.get(e);
  n.showLoaderOnDeny && Zt(Vt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Pn(n.preDeny(t, n.validationMessage))).then((o) => {
    o === !1 ? (e.hideLoading(), Dn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof o > "u" ? t : o
      }
    );
  }).catch((o) => Ai(e, o))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, bs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Ai = (e, t) => {
  e.rejectPromise(t);
}, Fr = (e, t) => {
  const n = se.innerParams.get(e);
  n.showLoaderOnConfirm && Zt(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Pn(n.preConfirm(t, n.validationMessage))).then((o) => {
    Re(Eo()) || o === !1 ? (e.hideLoading(), Dn(e)) : bs(e, typeof o > "u" ? t : o);
  }).catch((o) => Ai(e, o))) : bs(e, t);
};
function so() {
  const e = se.innerParams.get(this);
  if (!e)
    return;
  const t = se.domCache.get(this);
  Pe(t.loader), ko() ? e.icon && Ce(on()) : Aw(t), Ge([t.popup, t.actions], h.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Aw = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Ce(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Jd() && Pe(e.actions);
};
function Ti() {
  const e = se.innerParams.get(this), t = se.domCache.get(this);
  return t ? Co(t.popup, e.input) : null;
}
function Oi(e, t, n) {
  const o = se.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function xi(e, t) {
  const n = ne();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${h.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function Pi() {
  Oi(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function Ni() {
  Oi(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Ii() {
  xi(this.getInput(), !1);
}
function Si() {
  xi(this.getInput(), !0);
}
function $i(e) {
  const t = se.domCache.get(this), n = se.innerParams.get(this);
  Ye(t.validationMessage, e), t.validationMessage.className = h["validation-message"], n.customClass && n.customClass.validationMessage && te(t.validationMessage, n.customClass.validationMessage), Ce(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", h["validation-message"]), ai(o), te(o, h.inputerror));
}
function Di() {
  const e = se.domCache.get(this);
  e.validationMessage && Pe(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), Ge(t, h.inputerror));
}
const _t = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Tw = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Ow = {
  allowEnterKey: void 0
}, xw = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Mi = (e) => Object.prototype.hasOwnProperty.call(_t, e), Bi = (e) => Tw.indexOf(e) !== -1, Ri = (e) => Ow[e], Pw = (e) => {
  Mi(e) || Se(`Unknown parameter "${e}"`);
}, Nw = (e) => {
  xw.includes(e) && Se(`The parameter "${e}" is incompatible with toasts`);
}, Iw = (e) => {
  const t = Ri(e);
  t && ni(e, t);
}, Fi = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Se('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Se(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Pw(t), e.toast && Nw(t), Iw(t);
};
function Ui(e) {
  const t = De(), n = ne(), o = se.innerParams.get(this);
  if (!n || pt(n, o.hideClass.popup)) {
    Se("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = Sw(e), s = Object.assign({}, o, r);
  Fi(s), t && (t.dataset.swal2Theme = s.theme), hi(this, s), se.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Sw = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (Bi(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Se(`Invalid parameter to update: ${n}`);
  }), t;
};
function Vi() {
  var e;
  const t = se.domCache.get(this), n = se.innerParams.get(this);
  if (!n) {
    Hi(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), $w(this);
}
const $w = (e) => {
  Hi(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, Hi = (e) => {
  e.isAwaitingPromise ? (Fo(se, e), e.isAwaitingPromise = !0) : (Fo(Xt, e), Fo(se, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Fo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var Dw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Vi,
  close: Et,
  closeModal: Et,
  closePopup: Et,
  closeToast: Et,
  disableButtons: Ni,
  disableInput: Si,
  disableLoading: so,
  enableButtons: Pi,
  enableInput: Ii,
  getInput: Ti,
  handleAwaitingPromise: Dn,
  hideLoading: so,
  rejectPromise: ki,
  resetValidationMessage: Di,
  showValidationMessage: $i,
  update: Ui
});
const Mw = (e, t, n) => {
  e.toast ? Bw(e, t, n) : (Fw(t), Uw(t), Vw(e, t, n));
}, Bw = (e, t, n) => {
  t.popup.onclick = () => {
    e && (Rw(e) || e.timer || e.input) || n(an.close);
  };
}, Rw = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let ao = !1;
const Fw = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (ao = !0);
    };
  };
}, Uw = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (ao = !0);
    };
  };
}, Vw = (e, t, n) => {
  t.container.onclick = (o) => {
    if (ao) {
      ao = !1;
      return;
    }
    o.target === t.container && yo(e.allowOutsideClick) && n(an.backdrop);
  };
}, Hw = (e) => typeof e == "object" && e.jquery, vs = (e) => e instanceof Element || Hw(e), jw = (e) => {
  const t = {};
  return typeof e[0] == "object" && !vs(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || vs(r) ? t[n] = r : r !== void 0 && Ut(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Ww(...e) {
  return new this(...e);
}
function Yw(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const qw = () => R.timeout && R.timeout.getTimerLeft(), ji = () => {
  if (R.timeout)
    return ef(), R.timeout.stop();
}, Wi = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return $r(e), e;
  }
}, zw = () => {
  const e = R.timeout;
  return e && (e.running ? ji() : Wi());
}, Kw = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return $r(t, !0), t;
  }
}, Gw = () => !!(R.timeout && R.timeout.isRunning());
let ys = !1;
const Ko = {};
function Xw(e = "data-swal-template") {
  Ko[e] = this, ys || (document.body.addEventListener("click", Zw), ys = !0);
}
const Zw = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in Ko) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        Ko[n].fire({
          template: o
        });
        return;
      }
    }
};
class Jw {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new Jw();
const Qw = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, em = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, tm = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var nm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: jw,
  bindClickHandler: Xw,
  clickCancel: jf,
  clickConfirm: gi,
  clickDeny: Hf,
  enableLoading: Zt,
  fire: Ww,
  getActions: In,
  getCancelButton: rn,
  getCloseButton: Pr,
  getConfirmButton: lt,
  getContainer: De,
  getDenyButton: Vt,
  getFocusableElements: Nr,
  getFooter: si,
  getHtmlContainer: Or,
  getIcon: on,
  getIconContent: zd,
  getImage: ri,
  getInputLabel: Kd,
  getLoader: sn,
  getPopup: ne,
  getProgressSteps: xr,
  getTimerLeft: qw,
  getTimerProgressBar: _o,
  getTitle: oi,
  getValidationMessage: Eo,
  increaseTimer: Kw,
  isDeprecatedParameter: Ri,
  isLoading: Xd,
  isTimerRunning: Gw,
  isUpdatableParameter: Bi,
  isValidParameter: Mi,
  isVisible: Vf,
  mixin: Yw,
  off: tm,
  on: Qw,
  once: em,
  resumeTimer: Wi,
  showLoading: Zt,
  stopTimer: ji,
  toggleTimer: zw
});
class om {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Yi = ["swal-title", "swal-html", "swal-footer"], rm = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return fm(n), Object.assign(sm(n), am(n), im(n), lm(n), cm(n), um(n), dm(n, Yi));
}, sm = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((n) => {
    Dt(n, ["name", "value"]);
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (o in _t && typeof _t[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "boolean" ? t[o] = r !== "false" : o in _t && typeof _t[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "object" ? t[o] = JSON.parse(r) : t[o] = r);
  }), t;
}, am = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((n) => {
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (t[o] = new Function(`return ${r}`)());
  }), t;
}, im = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((n) => {
    Dt(n, ["type", "color", "aria-label"]);
    const o = n.getAttribute("type");
    if (!(!o || !["confirm", "cancel", "deny"].includes(o))) {
      if (t[`${o}ButtonText`] = n.innerHTML, t[`show${Lr(o)}Button`] = !0, n.hasAttribute("color")) {
        const r = n.getAttribute("color");
        r !== null && (t[`${o}ButtonColor`] = r);
      }
      if (n.hasAttribute("aria-label")) {
        const r = n.getAttribute("aria-label");
        r !== null && (t[`${o}ButtonAriaLabel`] = r);
      }
    }
  }), t;
}, lm = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Dt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, cm = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Dt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, um = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Dt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Dt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, dm = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Dt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, fm = (e) => {
  const t = Yi.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Se(`Unrecognized element <${o}>`);
  });
}, Dt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Se([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, qi = 10, wm = (e) => {
  var t, n;
  const o = De(), r = ne();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const s = window.getComputedStyle(document.body).overflowY;
  if (hm(o, r, e), setTimeout(() => {
    mm(o, r);
  }, qi), Ir() && (pm(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, s), Zf()), !ko() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const a = e.didOpen;
    setTimeout(() => a(r));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, io = (e) => {
  const t = ne();
  if (!t || e.target !== t)
    return;
  const n = De();
  n && (t.removeEventListener("animationend", io), t.removeEventListener("transitionend", io), n.style.overflowY = "auto", Ge(n, h["no-transition"]));
}, mm = (e, t) => {
  li(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", io), t.addEventListener("transitionend", io)) : e.style.overflowY = "auto";
}, pm = (e, t, n) => {
  Jf(), t && n !== "hidden" && sw(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, hm = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && te(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ce(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && te(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, qi)) : Ce(t, "grid"), te([document.documentElement, document.body], h.shown), n.heightAuto && n.backdrop && !n.toast && te([document.documentElement, document.body], h["height-auto"]);
};
var Es = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function gm(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Es.email), e.input === "url" && (e.inputValidator = Es.url));
}
function bm(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Se('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function vm(e) {
  gm(e), e.showLoaderOnConfirm && !e.preConfirm && Se(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), bm(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), cf(e);
}
let st;
var Fn = /* @__PURE__ */ new WeakMap();
class be {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Fd(
      this,
      Fn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    st = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Ud(Fn, this, this._main(st.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (Fi(Object.assign({}, n, t)), R.currentInstance) {
      const s = Xt.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), Ir() && yi();
    }
    R.currentInstance = st;
    const o = Em(t, n);
    vm(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const r = _m(st);
    return hi(st, o), se.innerParams.set(st, o), ym(st, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return ds(Fn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return ds(Fn, this).finally(t);
  }
}
const ym = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Xt.swalPromiseResolve.set(e, o), Xt.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    _w(e);
  }, t.denyButton.onclick = () => {
    kw(e);
  }, t.cancelButton.onclick = () => {
    Cw(e, s);
  }, t.closeButton.onclick = () => {
    s(an.close);
  }, Mw(n, t, s), Wf(R, n, s), ww(e, n), wm(n), km(R, n, s), Cm(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Em = (e, t) => {
  const n = rm(e), o = Object.assign({}, _t, t, n, e);
  return o.showClass = Object.assign({}, _t.showClass, o.showClass), o.hideClass = Object.assign({}, _t.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, _m = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        ne()
      ),
      container: (
        /** @type {HTMLElement} */
        De()
      ),
      actions: (
        /** @type {HTMLElement} */
        In()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        lt()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Vt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        rn()
      ),
      loader: (
        /** @type {HTMLElement} */
        sn()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Pr()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Eo()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        xr()
      )
    }
  );
  return se.domCache.set(e, t), t;
}, km = (e, t, n) => {
  const o = _o();
  Pe(o), t.timer && (e.timeout = new om(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Ce(o), Ve(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && $r(
      /** @type {number} */
      t.timer
    );
  })));
}, Cm = (e, t) => {
  if (!t.toast) {
    if (!yo(t.allowEnterKey)) {
      ni("allowEnterKey"), Tm();
      return;
    }
    Lm(e) || Am(e, t) || zo(-1, 1);
  }
}, Lm = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && Re(n))
      return n.focus(), !0;
  return !1;
}, Am = (e, t) => t.focusDeny && Re(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && Re(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && Re(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Tm = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
be.prototype.disableButtons = Ni;
be.prototype.enableButtons = Pi;
be.prototype.getInput = Ti;
be.prototype.disableInput = Si;
be.prototype.enableInput = Ii;
be.prototype.hideLoading = so;
be.prototype.disableLoading = so;
be.prototype.showValidationMessage = $i;
be.prototype.resetValidationMessage = Di;
be.prototype.close = Et;
be.prototype.closePopup = Et;
be.prototype.closeModal = Et;
be.prototype.closeToast = Et;
be.prototype.rejectPromise = ki;
be.prototype.update = Ui;
be.prototype._destroy = Vi;
Object.assign(be, nm);
Object.keys(Dw).forEach((e) => {
  be[e] = function(...t) {
    if (st && st[e])
      return st[e](...t);
  };
});
be.DismissReason = an;
be.version = "11.26.17";
const Go = be;
Go.default = Go;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
let pn = !1;
const Ne = {
  /**
   * Call this once in your main app (e.g., main.ts)
   */
  init(e) {
    pn = e === !0 || e === "true";
  },
  log: (...e) => {
    pn && console.log(...e);
  },
  warn: (...e) => {
    pn && console.warn(...e);
  },
  error: (...e) => {
    pn && console.error("[DEBUG MODE]", ...e);
  },
  // Helper to check current state
  getStatus: () => pn
}, Om = {
  apiKey: "AIzaSyCtP4XQ5f3dxdCrs7a2wR0_hPnb6IoRJI8",
  authDomain: "app-bloomingrice.firebaseapp.com",
  projectId: "app-bloomingrice",
  storageBucket: "app-bloomingrice.firebasestorage.app",
  messagingSenderId: "646508448652",
  appId: "1:646508448652:web:4e6aa0247ce7733774e4a9",
  measurementId: "G-4MNQYGYD9Y"
};
Sl(Om);
function xm(e) {
  const t = gn(null), n = gn(!1), o = gn(!1), r = async (w, k, v) => {
    o.value = !0;
    const f = bn.isNativePlatform();
    Ne.log("Initializing notifications for platform:", f ? "Native" : "Web/PWA"), f ? await s(k, v) : await i(w, k, v), o.value = !1;
  }, s = async (w, k) => {
    try {
      await Ot.createChannel({
        id: "default",
        name: "Default",
        description: "General Notifications",
        importance: 5,
        // 5 = high (this makes it pop up as a banner)
        visibility: 1,
        // 1 = public
        vibration: !0
      });
      const { channels: v } = await Ot.listChannels();
      Ne.log("Existing Notification Channels:", v);
      const f = v.some((C) => C.id === "default");
      Ne.log('Is "default" channel created successfully?', f), await Ot.register(), Ot.addListener("registration", async (C) => {
        t.value = C.value, await e.saveToken({ fcm_token: C.value, platform: "android" }), n.value = !0;
      }), Ot.addListener("pushNotificationReceived", (C) => {
        var m, E;
        Ne.log("Message received 1 : ", JSON.stringify(C, null, 2));
        const P = ((m = C.data) == null ? void 0 : m.title) || "??", g = ((E = C.data) == null ? void 0 : E.body) || "0", L = k("notification.new_order_title", { tableNum: P }), d = k("notification.new_order_body", { Subtotal: g });
        vn.fire({
          title: L,
          text: d,
          icon: "info",
          toast: !0,
          position: "top-end",
          showConfirmButton: !1,
          timer: 3e3,
          timerProgressBar: !0
        });
      });
    } catch (v) {
      Ne.error("Native push init failed", v);
    }
  }, a = async () => {
    if (bn.isNativePlatform()) {
      let w = await Ot.checkPermissions();
      return w.receive !== "granted" && (w = await Ot.requestPermissions()), w.receive === "granted";
    }
    if (!("Notification" in window))
      return Ne.error("This browser does not support desktop notification"), !1;
    try {
      return await Notification.requestPermission() === "granted" ? (Ne.log("Notification permission granted."), !0) : (Ne.warn("Notification permission denied."), !1);
    } catch (w) {
      return Ne.error("Error requesting notification permission", w), !1;
    }
  }, i = async (w, k, v) => {
    const f = Pl();
    return Nl(f, (C) => {
      var m, E;
      Ne.log("Message received: ", JSON.stringify(C, null, 2));
      const P = ((m = C.data) == null ? void 0 : m.title) || "??", g = ((E = C.data) == null ? void 0 : E.body) || "0", L = v("notification.new_order_title", { tableNum: P }), d = v("notification.new_order_body", { Subtotal: g });
      vn.fire({
        title: L,
        text: d,
        icon: "info",
        toast: !0,
        position: "top-end",
        showConfirmButton: !1,
        timer: 3e3,
        timerProgressBar: !0
      });
    }), await l(f, w, k);
  }, l = async (w, k, v) => {
    Ne.log("registerDevice", { messaging: w, vapidKey: k, merchantId: v }), o.value = !0;
    try {
      const f = await Il(w, { vapidKey: k });
      f && (Ne.log("Device token retrieved:", f), t.value = f, await e.saveToken({
        fcm_token: f,
        platform: "web"
      }), n.value = !0);
    } catch (f) {
      Ne.error("Notification registration failed", f);
    } finally {
      o.value = !1;
    }
  };
  return {
    deviceToken: t,
    isSubscribed: n,
    loading: o,
    initNotificationListener: r,
    requestPermission: a
  };
}
/*!
  * shared v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function ct(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const _s = {};
function Pm(e) {
  _s[e] || (_s[e] = !0, ct(e));
}
const ht = typeof window < "u";
let Fe, Mt;
if (process.env.NODE_ENV !== "production") {
  const e = ht && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Fe = (t) => {
    e.mark(t);
  }, Mt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Nm = /\{([0-9a-zA-Z]+)\}/g;
function Lo(e, ...t) {
  return t.length === 1 && Z(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Nm, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const gt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Im = (e, t, n) => Sm({ l: e, k: t, s: n }), Sm = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ee = (e) => typeof e == "number" && isFinite(e), $m = (e) => Ur(e) === "[object Date]", lo = (e) => Ur(e) === "[object RegExp]", Ao = (e) => X(e) && Object.keys(e).length === 0, _e = Object.assign, Dm = Object.create, oe = (e = null) => Dm(e);
let ks;
const Nt = () => ks || (ks = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : oe());
function Cs(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Ls(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Mm(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (o, r, s) => `${r}="${Ls(s)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (o, r, s) => `${r}='${Ls(s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && ct("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((o) => {
    e = e.replace(o, "$1javascript&#58;");
  }), e;
}
const Bm = Object.prototype.hasOwnProperty;
function Je(e, t) {
  return Bm.call(e, t);
}
const he = Array.isArray, le = (e) => typeof e == "function", $ = (e) => typeof e == "string", pe = (e) => typeof e == "boolean", Z = (e) => e !== null && typeof e == "object", Rm = (e) => Z(e) && le(e.then) && le(e.catch), zi = Object.prototype.toString, Ur = (e) => zi.call(e), X = (e) => Ur(e) === "[object Object]", Fm = (e) => e == null ? "" : he(e) || X(e) && e.toString === zi ? JSON.stringify(e, null, 2) : String(e);
function Vr(e, t = "") {
  return e.reduce((n, o, r) => r === 0 ? n + o : n + t + o, "");
}
const As = 2;
function Um(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let a = 0; a < o.length; a++)
    if (r += o[a].length + 1, r >= t) {
      for (let i = a - As; i <= a + As || n > r; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const l = i + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[i]}`);
        const w = o[i].length;
        if (i === a) {
          const k = t - (r - w) + 1, v = Math.max(1, n > r ? w - k : n - t);
          s.push("   |  " + " ".repeat(k) + "^".repeat(v));
        } else if (i > a) {
          if (n > r) {
            const k = Math.max(Math.min(n - r, w), 1);
            s.push("   |  " + "^".repeat(k));
          }
          r += w + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Vm() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const r = e.get(n);
      r && r.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const r = e.get(n);
      r && r.splice(r.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((r) => r(o)), (e.get("*") || []).slice().map((r) => r(n, o));
    }
  };
}
const Un = (e) => !Z(e) || he(e);
function jn(e, t) {
  if (Un(e) || Un(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: r } = n.pop();
    Object.keys(o).forEach((s) => {
      s !== "__proto__" && (Z(o[s]) && !Z(r[s]) && (r[s] = Array.isArray(o[s]) ? [] : oe()), Un(r[s]) || Un(o[s]) ? r[s] = o[s] : n.push({ src: o[s], des: r[s] }));
    });
  }
}
/*!
  * message-compiler v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Hm(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Xo(e, t, n) {
  return { start: e, end: t };
}
const Y = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, jm = 17, Wm = {
  // tokenizer error messages
  [Y.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Y.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Y.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Y.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Y.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Y.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Y.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Y.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Y.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Y.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Y.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Y.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Y.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Y.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Y.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function ln(e, t, n = {}) {
  const { domain: o, messages: r, args: s } = n, a = process.env.NODE_ENV !== "production" ? Lo((r || Wm)[e] || "", ...s || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function Ym(e) {
  throw e;
}
const qm = /<\/?[\w\s="/.':;#-\/]+>/, zm = (e) => qm.test(e), nt = " ", Km = "\r", Te = `
`, Gm = "\u2028", Xm = "\u2029";
function Zm(e) {
  const t = e;
  let n = 0, o = 1, r = 1, s = 0;
  const a = (_) => t[_] === Km && t[_ + 1] === Te, i = (_) => t[_] === Te, l = (_) => t[_] === Xm, w = (_) => t[_] === Gm, k = (_) => a(_) || i(_) || l(_) || w(_), v = () => n, f = () => o, C = () => r, P = () => s, g = (_) => a(_) || l(_) || w(_) ? Te : t[_], L = () => g(n), d = () => g(n + s);
  function m() {
    return s = 0, k(n) && (o++, r = 0), a(n) && n++, n++, r++, t[n];
  }
  function E() {
    return a(n + s) && s++, s++, t[n + s];
  }
  function b() {
    n = 0, o = 1, r = 1, s = 0;
  }
  function T(_ = 0) {
    s = _;
  }
  function x() {
    const _ = n + s;
    for (; _ !== n; )
      m();
    s = 0;
  }
  return {
    index: v,
    line: f,
    column: C,
    peekOffset: P,
    charAt: g,
    currentChar: L,
    currentPeek: d,
    next: m,
    peek: E,
    reset: b,
    resetPeek: T,
    skipToPeek: x
  };
}
const ft = void 0, Jm = ".", Ts = "'", Qm = "tokenizer";
function ep(e, t = {}) {
  const n = t.location !== !1, o = Zm(e), r = () => o.index(), s = () => Hm(o.line(), o.column(), o.index()), a = s(), i = r(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, w = () => l, { onError: k } = t;
  function v(c, u, A, ...M) {
    const ie = w();
    if (u.column += A, u.offset += A, k) {
      const de = n ? Xo(ie.startLoc, u) : null, G = ln(c, de, {
        domain: Qm,
        args: M
      });
      k(G);
    }
  }
  function f(c, u, A) {
    c.endLoc = s(), c.currentType = u;
    const M = { type: u };
    return n && (M.loc = Xo(c.startLoc, c.endLoc)), A != null && (M.value = A), M;
  }
  const C = (c) => f(
    c,
    13
    /* TokenTypes.EOF */
  );
  function P(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (v(Y.EXPECTED_TOKEN, s(), 0, u), "");
  }
  function g(c) {
    let u = "";
    for (; c.currentPeek() === nt || c.currentPeek() === Te; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function L(c) {
    const u = g(c);
    return c.skipToPeek(), u;
  }
  function d(c) {
    if (c === ft)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function m(c) {
    if (c === ft)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function E(c, u) {
    const { currentType: A } = u;
    if (A !== 2)
      return !1;
    g(c);
    const M = d(c.currentPeek());
    return c.resetPeek(), M;
  }
  function b(c, u) {
    const { currentType: A } = u;
    if (A !== 2)
      return !1;
    g(c);
    const M = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), ie = m(M);
    return c.resetPeek(), ie;
  }
  function T(c, u) {
    const { currentType: A } = u;
    if (A !== 2)
      return !1;
    g(c);
    const M = c.currentPeek() === Ts;
    return c.resetPeek(), M;
  }
  function x(c, u) {
    const { currentType: A } = u;
    if (A !== 7)
      return !1;
    g(c);
    const M = c.currentPeek() === ".";
    return c.resetPeek(), M;
  }
  function _(c, u) {
    const { currentType: A } = u;
    if (A !== 8)
      return !1;
    g(c);
    const M = d(c.currentPeek());
    return c.resetPeek(), M;
  }
  function D(c, u) {
    const { currentType: A } = u;
    if (!(A === 7 || A === 11))
      return !1;
    g(c);
    const M = c.currentPeek() === ":";
    return c.resetPeek(), M;
  }
  function B(c, u) {
    const { currentType: A } = u;
    if (A !== 9)
      return !1;
    const M = () => {
      const de = c.currentPeek();
      return de === "{" ? d(c.peek()) : de === "@" || de === "|" || de === ":" || de === "." || de === nt || !de ? !1 : de === Te ? (c.peek(), M()) : H(c, !1);
    }, ie = M();
    return c.resetPeek(), ie;
  }
  function U(c) {
    g(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function H(c, u = !0) {
    const A = (ie = !1, de = "") => {
      const G = c.currentPeek();
      return G === "{" || G === "@" || !G ? ie : G === "|" ? !(de === nt || de === Te) : G === nt ? (c.peek(), A(!0, nt)) : G === Te ? (c.peek(), A(!0, Te)) : !0;
    }, M = A();
    return u && c.resetPeek(), M;
  }
  function z(c, u) {
    const A = c.currentChar();
    return A === ft ? ft : u(A) ? (c.next(), A) : null;
  }
  function ue(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function j(c) {
    return z(c, ue);
  }
  function I(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function N(c) {
    return z(c, I);
  }
  function F(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function S(c) {
    return z(c, F);
  }
  function q(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function W(c) {
    return z(c, q);
  }
  function K(c) {
    let u = "", A = "";
    for (; u = S(c); )
      A += u;
    return A;
  }
  function ae(c) {
    let u = "";
    for (; ; ) {
      const A = c.currentChar();
      if (A === "{" || A === "}" || A === "@" || A === "|" || !A)
        break;
      if (A === nt || A === Te)
        if (H(c))
          u += A, c.next();
        else {
          if (U(c))
            break;
          u += A, c.next();
        }
      else
        u += A, c.next();
    }
    return u;
  }
  function ce(c) {
    L(c);
    let u = "", A = "";
    for (; u = N(c); )
      A += u;
    const M = c.currentChar();
    if (M && M !== "}" && M !== ft && M !== nt && M !== Te && M !== "　") {
      const ie = ye(c);
      return v(Y.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, A + ie), A + ie;
    }
    return c.currentChar() === ft && v(Y.UNTERMINATED_CLOSING_BRACE, s(), 0), A;
  }
  function ve(c) {
    L(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${K(c)}`) : u += K(c), c.currentChar() === ft && v(Y.UNTERMINATED_CLOSING_BRACE, s(), 0), u;
  }
  function Ae(c) {
    return c !== Ts && c !== Te;
  }
  function ut(c) {
    L(c), P(c, "'");
    let u = "", A = "";
    for (; u = z(c, Ae); )
      u === "\\" ? A += Xe(c) : A += u;
    const M = c.currentChar();
    return M === Te || M === ft ? (v(Y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), M === Te && (c.next(), P(c, "'")), A) : (P(c, "'"), A);
  }
  function Xe(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return et(c, u, 4);
      case "U":
        return et(c, u, 6);
      default:
        return v(Y.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, u), "";
    }
  }
  function et(c, u, A) {
    P(c, u);
    let M = "";
    for (let ie = 0; ie < A; ie++) {
      const de = W(c);
      if (!de) {
        v(Y.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${u}${M}${c.currentChar()}`);
        break;
      }
      M += de;
    }
    return `\\${u}${M}`;
  }
  function Ze(c) {
    return c !== "{" && c !== "}" && c !== nt && c !== Te;
  }
  function ye(c) {
    L(c);
    let u = "", A = "";
    for (; u = z(c, Ze); )
      A += u;
    return A;
  }
  function qe(c) {
    let u = "", A = "";
    for (; u = j(c); )
      A += u;
    return A;
  }
  function dt(c) {
    const u = (A) => {
      const M = c.currentChar();
      return M === "{" || M === "@" || M === "|" || M === "(" || M === ")" || !M || M === nt ? A : (A += M, c.next(), u(A));
    };
    return u("");
  }
  function tt(c) {
    L(c);
    const u = P(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return L(c), u;
  }
  function cn(c, u) {
    let A = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && v(Y.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), c.next(), A = f(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), L(c), u.braceNest++, A;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && v(Y.EMPTY_PLACEHOLDER, s(), 0), c.next(), A = f(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && L(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), A;
      case "@":
        return u.braceNest > 0 && v(Y.UNTERMINATED_CLOSING_BRACE, s(), 0), A = Lt(c, u) || C(u), u.braceNest = 0, A;
      default: {
        let ie = !0, de = !0, G = !0;
        if (U(c))
          return u.braceNest > 0 && v(Y.UNTERMINATED_CLOSING_BRACE, s(), 0), A = f(u, 1, tt(c)), u.braceNest = 0, u.inLinked = !1, A;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return v(Y.UNTERMINATED_CLOSING_BRACE, s(), 0), u.braceNest = 0, un(c, u);
        if (ie = E(c, u))
          return A = f(u, 4, ce(c)), L(c), A;
        if (de = b(c, u))
          return A = f(u, 5, ve(c)), L(c), A;
        if (G = T(c, u))
          return A = f(u, 6, ut(c)), L(c), A;
        if (!ie && !de && !G)
          return A = f(u, 12, ye(c)), v(Y.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, A.value), L(c), A;
        break;
      }
    }
    return A;
  }
  function Lt(c, u) {
    const { currentType: A } = u;
    let M = null;
    const ie = c.currentChar();
    switch ((A === 7 || A === 8 || A === 11 || A === 9) && (ie === Te || ie === nt) && v(Y.INVALID_LINKED_FORMAT, s(), 0), ie) {
      case "@":
        return c.next(), M = f(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, M;
      case ".":
        return L(c), c.next(), f(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return L(c), c.next(), f(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return U(c) ? (M = f(u, 1, tt(c)), u.braceNest = 0, u.inLinked = !1, M) : x(c, u) || D(c, u) ? (L(c), Lt(c, u)) : _(c, u) ? (L(c), f(u, 11, qe(c))) : B(c, u) ? (L(c), ie === "{" ? cn(c, u) || M : f(u, 10, dt(c))) : (A === 7 && v(Y.INVALID_LINKED_FORMAT, s(), 0), u.braceNest = 0, u.inLinked = !1, un(c, u));
    }
  }
  function un(c, u) {
    let A = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return cn(c, u) || C(u);
    if (u.inLinked)
      return Lt(c, u) || C(u);
    switch (c.currentChar()) {
      case "{":
        return cn(c, u) || C(u);
      case "}":
        return v(Y.UNBALANCED_CLOSING_BRACE, s(), 0), c.next(), f(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Lt(c, u) || C(u);
      default: {
        if (U(c))
          return A = f(u, 1, tt(c)), u.braceNest = 0, u.inLinked = !1, A;
        if (H(c))
          return f(u, 0, ae(c));
        break;
      }
    }
    return A;
  }
  function Po() {
    const { currentType: c, offset: u, startLoc: A, endLoc: M } = l;
    return l.lastType = c, l.lastOffset = u, l.lastStartLoc = A, l.lastEndLoc = M, l.offset = r(), l.startLoc = s(), o.currentChar() === ft ? f(
      l,
      13
      /* TokenTypes.EOF */
    ) : un(o, l);
  }
  return {
    nextToken: Po,
    currentOffset: r,
    currentPosition: s,
    context: w
  };
}
const tp = "parser", np = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function op(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function rp(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(d, m, E, b, ...T) {
    const x = d.currentPosition();
    if (x.offset += b, x.column += b, n) {
      const _ = t ? Xo(E, x) : null, D = ln(m, _, {
        domain: tp,
        args: T
      });
      n(D);
    }
  }
  function r(d, m, E) {
    const b = { type: d };
    return t && (b.start = m, b.end = m, b.loc = { start: E, end: E }), b;
  }
  function s(d, m, E, b) {
    t && (d.end = m, d.loc && (d.loc.end = E));
  }
  function a(d, m) {
    const E = d.context(), b = r(3, E.offset, E.startLoc);
    return b.value = m, s(b, d.currentOffset(), d.currentPosition()), b;
  }
  function i(d, m) {
    const E = d.context(), { lastOffset: b, lastStartLoc: T } = E, x = r(5, b, T);
    return x.index = parseInt(m, 10), d.nextToken(), s(x, d.currentOffset(), d.currentPosition()), x;
  }
  function l(d, m) {
    const E = d.context(), { lastOffset: b, lastStartLoc: T } = E, x = r(4, b, T);
    return x.key = m, d.nextToken(), s(x, d.currentOffset(), d.currentPosition()), x;
  }
  function w(d, m) {
    const E = d.context(), { lastOffset: b, lastStartLoc: T } = E, x = r(9, b, T);
    return x.value = m.replace(np, op), d.nextToken(), s(x, d.currentOffset(), d.currentPosition()), x;
  }
  function k(d) {
    const m = d.nextToken(), E = d.context(), { lastOffset: b, lastStartLoc: T } = E, x = r(8, b, T);
    return m.type !== 11 ? (o(d, Y.UNEXPECTED_EMPTY_LINKED_MODIFIER, E.lastStartLoc, 0), x.value = "", s(x, b, T), {
      nextConsumeToken: m,
      node: x
    }) : (m.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, ot(m)), x.value = m.value || "", s(x, d.currentOffset(), d.currentPosition()), {
      node: x
    });
  }
  function v(d, m) {
    const E = d.context(), b = r(7, E.offset, E.startLoc);
    return b.value = m, s(b, d.currentOffset(), d.currentPosition()), b;
  }
  function f(d) {
    const m = d.context(), E = r(6, m.offset, m.startLoc);
    let b = d.nextToken();
    if (b.type === 8) {
      const T = k(d);
      E.modifier = T.node, b = T.nextConsumeToken || d.nextToken();
    }
    switch (b.type !== 9 && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(b)), b = d.nextToken(), b.type === 2 && (b = d.nextToken()), b.type) {
      case 10:
        b.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(b)), E.key = v(d, b.value || "");
        break;
      case 4:
        b.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(b)), E.key = l(d, b.value || "");
        break;
      case 5:
        b.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(b)), E.key = i(d, b.value || "");
        break;
      case 6:
        b.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(b)), E.key = w(d, b.value || "");
        break;
      default: {
        o(d, Y.UNEXPECTED_EMPTY_LINKED_KEY, m.lastStartLoc, 0);
        const T = d.context(), x = r(7, T.offset, T.startLoc);
        return x.value = "", s(x, T.offset, T.startLoc), E.key = x, s(E, T.offset, T.startLoc), {
          nextConsumeToken: b,
          node: E
        };
      }
    }
    return s(E, d.currentOffset(), d.currentPosition()), {
      node: E
    };
  }
  function C(d) {
    const m = d.context(), E = m.currentType === 1 ? d.currentOffset() : m.offset, b = m.currentType === 1 ? m.endLoc : m.startLoc, T = r(2, E, b);
    T.items = [];
    let x = null;
    do {
      const B = x || d.nextToken();
      switch (x = null, B.type) {
        case 0:
          B.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(B)), T.items.push(a(d, B.value || ""));
          break;
        case 5:
          B.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(B)), T.items.push(i(d, B.value || ""));
          break;
        case 4:
          B.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(B)), T.items.push(l(d, B.value || ""));
          break;
        case 6:
          B.value == null && o(d, Y.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, ot(B)), T.items.push(w(d, B.value || ""));
          break;
        case 7: {
          const U = f(d);
          T.items.push(U.node), x = U.nextConsumeToken || null;
          break;
        }
      }
    } while (m.currentType !== 13 && m.currentType !== 1);
    const _ = m.currentType === 1 ? m.lastOffset : d.currentOffset(), D = m.currentType === 1 ? m.lastEndLoc : d.currentPosition();
    return s(T, _, D), T;
  }
  function P(d, m, E, b) {
    const T = d.context();
    let x = b.items.length === 0;
    const _ = r(1, m, E);
    _.cases = [], _.cases.push(b);
    do {
      const D = C(d);
      x || (x = D.items.length === 0), _.cases.push(D);
    } while (T.currentType !== 13);
    return x && o(d, Y.MUST_HAVE_MESSAGES_IN_PLURAL, E, 0), s(_, d.currentOffset(), d.currentPosition()), _;
  }
  function g(d) {
    const m = d.context(), { offset: E, startLoc: b } = m, T = C(d);
    return m.currentType === 13 ? T : P(d, E, b, T);
  }
  function L(d) {
    const m = ep(d, _e({}, e)), E = m.context(), b = r(0, E.offset, E.startLoc);
    return t && b.loc && (b.loc.source = d), b.body = g(m), e.onCacheKey && (b.cacheKey = e.onCacheKey(d)), E.currentType !== 13 && o(m, Y.UNEXPECTED_LEXICAL_ANALYSIS, E.lastStartLoc, 0, d[E.offset] || ""), s(b, m.currentOffset(), m.currentPosition()), b;
  }
  return { parse: L };
}
function ot(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function sp(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function Os(e, t) {
  for (let n = 0; n < e.length; n++)
    Hr(e[n], t);
}
function Hr(e, t) {
  switch (e.type) {
    case 1:
      Os(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Os(e.items, t);
      break;
    case 6: {
      Hr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function ap(e, t = {}) {
  const n = sp(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Hr(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function ip(e) {
  const t = e.body;
  return t.type === 2 ? xs(t) : t.cases.forEach((n) => xs(n)), e;
}
function xs(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = Vr(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const lp = "minifier";
function jt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      jt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        jt(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        jt(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      jt(t.key), t.k = t.key, delete t.key, t.modifier && (jt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw ln(Y.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: lp,
          args: [e.type]
        });
  }
  delete e.type;
}
const cp = "parser";
function up(e, t) {
  const { filename: n, breakLineCode: o, needIndent: r } = t, s = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: r,
    indentLevel: 0
  };
  s && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(g, L) {
    a.code += g;
  }
  function w(g, L = !0) {
    const d = L ? o : "";
    l(r ? d + "  ".repeat(g) : d);
  }
  function k(g = !0) {
    const L = ++a.indentLevel;
    g && w(L);
  }
  function v(g = !0) {
    const L = --a.indentLevel;
    g && w(L);
  }
  function f() {
    w(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: k,
    deindent: v,
    newline: f,
    helper: (g) => `_${g}`,
    needIndent: () => a.needIndent
  };
}
function dp(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Jt(e, t.key), t.modifier ? (e.push(", "), Jt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function fp(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const r = t.items.length;
  for (let s = 0; s < r && (Jt(e, t.items[s]), s !== r - 1); s++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function wp(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const r = t.cases.length;
    for (let s = 0; s < r && (Jt(e, t.cases[s]), s !== r - 1); s++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function mp(e, t) {
  t.body ? Jt(e, t.body) : e.push("null");
}
function Jt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      mp(e, t);
      break;
    case 1:
      wp(e, t);
      break;
    case 2:
      fp(e, t);
      break;
    case 6:
      dp(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw ln(Y.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: cp,
          args: [t.type]
        });
  }
}
const pp = (e, t = {}) => {
  const n = $(t.mode) ? t.mode : "normal", o = $(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = up(e, {
    filename: o,
    breakLineCode: r,
    needIndent: s
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(s), a.length > 0 && (i.push(`const { ${Vr(a.map((k) => `${k}: _${k}`), ", ")} } = ctx`), i.newline()), i.push("return "), Jt(i, e), i.deindent(s), i.push("}"), delete e.helpers;
  const { code: l, map: w } = i.context();
  return {
    ast: e,
    code: l,
    map: w ? w.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function hp(e, t = {}) {
  const n = _e({}, t), o = !!n.jit, r = !!n.minify, s = n.optimize == null ? !0 : n.optimize, i = rp(n).parse(e);
  return o ? (s && ip(i), r && jt(i), { ast: i, code: "" }) : (ap(i, n), pp(i, n));
}
/*!
  * core-base v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function gp() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Qe(e) {
  return Z(e) && jr(e) === 0 && (Je(e, "b") || Je(e, "body"));
}
const Ki = ["b", "body"];
function bp(e) {
  return kt(e, Ki);
}
const Gi = ["c", "cases"];
function vp(e) {
  return kt(e, Gi, []);
}
const Xi = ["s", "static"];
function yp(e) {
  return kt(e, Xi);
}
const Zi = ["i", "items"];
function Ep(e) {
  return kt(e, Zi, []);
}
const Ji = ["t", "type"];
function jr(e) {
  return kt(e, Ji);
}
const Qi = ["v", "value"];
function Vn(e, t) {
  const n = kt(e, Qi);
  if (n != null)
    return n;
  throw yn(t);
}
const el = ["m", "modifier"];
function _p(e) {
  return kt(e, el);
}
const tl = ["k", "key"];
function kp(e) {
  const t = kt(e, tl);
  if (t)
    return t;
  throw yn(
    6
    /* NodeTypes.Linked */
  );
}
function kt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (Je(e, r) && e[r] != null)
      return e[r];
  }
  return n;
}
const nl = [
  ...Ki,
  ...Gi,
  ...Xi,
  ...Zi,
  ...tl,
  ...el,
  ...Qi,
  ...Ji
];
function yn(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Uo(e) {
  return (n) => Cp(n, e);
}
function Cp(e, t) {
  const n = bp(t);
  if (n == null)
    throw yn(
      0
      /* NodeTypes.Resource */
    );
  if (jr(n) === 1) {
    const s = vp(n);
    return e.plural(s.reduce((a, i) => [
      ...a,
      Ps(e, i)
    ], []));
  } else
    return Ps(e, n);
}
function Ps(e, t) {
  const n = yp(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = Ep(t).reduce((r, s) => [...r, Zo(e, s)], []);
    return e.normalize(o);
  }
}
function Zo(e, t) {
  const n = jr(t);
  switch (n) {
    case 3:
      return Vn(t, n);
    case 9:
      return Vn(t, n);
    case 4: {
      const o = t;
      if (Je(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Je(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw yn(n);
    }
    case 5: {
      const o = t;
      if (Je(o, "i") && Ee(o.i))
        return e.interpolate(e.list(o.i));
      if (Je(o, "index") && Ee(o.index))
        return e.interpolate(e.list(o.index));
      throw yn(n);
    }
    case 6: {
      const o = t, r = _p(o), s = kp(o);
      return e.linked(Zo(e, s), r ? Zo(e, r) : void 0, e.type);
    }
    case 7:
      return Vn(t, n);
    case 8:
      return Vn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const Lp = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Ap(e, t) {
  t && zm(e) && ct(Lo(Lp, { source: e }));
}
const Tp = (e) => e;
let Hn = oe();
function Op(e, t = {}) {
  let n = !1;
  const o = t.onError || Ym;
  return t.onError = (r) => {
    n = !0, o(r);
  }, { ...hp(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function xp(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && $(e)) {
    const n = pe(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ap(e, n);
    const r = (t.onCacheKey || Tp)(e), s = Hn[r];
    if (s)
      return s;
    const { ast: a, detectError: i } = Op(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Uo(a);
    return i ? l : Hn[r] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Qe(e))
      return ct(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = Hn[n];
      return o || (Hn[n] = Uo(e));
    } else
      return Uo(e);
  }
}
let En = null;
function Pp(e) {
  En = e;
}
function Np(e, t, n) {
  En && En.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Ip = /* @__PURE__ */ Sp("function:translate");
function Sp(e) {
  return (t) => En && En.emit(e, t);
}
const Oe = {
  INVALID_ARGUMENT: jm,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, $p = 24;
function wt(e) {
  return ln(e, null, process.env.NODE_ENV !== "production" ? { messages: Dp } : void 0);
}
const Dp = {
  [Oe.INVALID_ARGUMENT]: "Invalid arguments",
  [Oe.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Oe.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Oe.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Oe.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Oe.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Oe.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Wr(e, t) {
  return t.locale != null ? Ns(t.locale) : Ns(e.locale);
}
let Vo;
function Ns(e) {
  if ($(e))
    return e;
  if (le(e)) {
    if (e.resolvedOnce && Vo != null)
      return Vo;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Rm(t))
        throw wt(Oe.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Vo = t;
    } else
      throw wt(Oe.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw wt(Oe.NOT_SUPPORT_LOCALE_TYPE);
}
function Mp(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...he(t) ? t : Z(t) ? Object.keys(t) : $(t) ? [t] : [n]
  ])];
}
function ol(e, t, n) {
  const o = $(n) ? n : co, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let s = r.__localeChainCache.get(o);
  if (!s) {
    s = [];
    let a = [n];
    for (; he(a); )
      a = Is(s, a, t);
    const i = he(t) || !X(t) ? t : t.default ? t.default : null;
    a = $(i) ? [i] : i, he(a) && Is(s, a, !1), r.__localeChainCache.set(o, s);
  }
  return s;
}
function Is(e, t, n) {
  let o = !0;
  for (let r = 0; r < t.length && pe(o); r++) {
    const s = t[r];
    $(s) && (o = Bp(e, t[r], n));
  }
  return o;
}
function Bp(e, t, n) {
  let o;
  const r = t.split("-");
  do {
    const s = r.join("-");
    o = Rp(e, s, n), r.splice(-1, 1);
  } while (r.length && o === !0);
  return o;
}
function Rp(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (he(n) || X(n)) && n[r] && (o = n[r]);
  }
  return o;
}
const Ct = [];
Ct[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ct[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ct[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ct[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ct[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ct[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ct[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Fp = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Up(e) {
  return Fp.test(e);
}
function Vp(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Hp(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function jp(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Up(t) ? Vp(t) : "*" + t;
}
function Wp(e) {
  const t = [];
  let n = -1, o = 0, r = 0, s, a, i, l, w, k, v;
  const f = [];
  f[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, f[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, f[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    f[
      0
      /* Actions.APPEND */
    ](), r++;
  }, f[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, o = 4, f[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, a === void 0 || (a = jp(a), a === !1))
        return !1;
      f[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function C() {
    const P = e[n + 1];
    if (o === 5 && P === "'" || o === 6 && P === '"')
      return n++, i = "\\" + P, f[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, s = e[n], !(s === "\\" && C())) {
      if (l = Hp(s), v = Ct[o], w = v[l] || v.l || 8, w === 8 || (o = w[0], w[1] !== void 0 && (k = f[w[1]], k && (i = s, k() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const Ss = /* @__PURE__ */ new Map();
function Yp(e, t) {
  return Z(e) ? e[t] : null;
}
function qp(e, t) {
  if (!Z(e))
    return null;
  let n = Ss.get(t);
  if (n || (n = Wp(t), n && Ss.set(t, n)), !n)
    return null;
  const o = n.length;
  let r = e, s = 0;
  for (; s < o; ) {
    const a = n[s];
    if (nl.includes(a) && Qe(r))
      return null;
    const i = r[a];
    if (i === void 0 || le(r))
      return null;
    r = i, s++;
  }
  return r;
}
const Me = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, zp = 8, Kp = {
  [Me.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Me.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Me.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Me.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Me.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Me.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Me.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Bt(e, ...t) {
  return Lo(Kp[e], ...t);
}
const Gp = "11.2.8", To = -1, co = "en-US", uo = "", $s = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Xp() {
  return {
    upper: (e, t) => t === "text" && $(e) ? e.toUpperCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && $(e) ? e.toLowerCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && $(e) ? $s(e) : t === "vnode" && Z(e) && "__v_isVNode" in e ? $s(e.children) : e
  };
}
let rl;
function Zp(e) {
  rl = e;
}
let sl;
function Jp(e) {
  sl = e;
}
let al;
function Qp(e) {
  al = e;
}
let il = null;
const eh = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  il = e;
}, th = /* @__NO_SIDE_EFFECTS__ */ () => il;
let ll = null;
const Ds = (e) => {
  ll = e;
}, nh = () => ll;
let Ms = 0;
function oh(e = {}) {
  const t = le(e.onWarn) ? e.onWarn : ct, n = $(e.version) ? e.version : Gp, o = $(e.locale) || le(e.locale) ? e.locale : co, r = le(o) ? co : o, s = he(e.fallbackLocale) || X(e.fallbackLocale) || $(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, a = X(e.messages) ? e.messages : Ho(r), i = X(e.datetimeFormats) ? e.datetimeFormats : Ho(r), l = X(e.numberFormats) ? e.numberFormats : Ho(r), w = _e(oe(), e.modifiers, Xp()), k = e.pluralRules || oe(), v = le(e.missing) ? e.missing : null, f = pe(e.missingWarn) || lo(e.missingWarn) ? e.missingWarn : !0, C = pe(e.fallbackWarn) || lo(e.fallbackWarn) ? e.fallbackWarn : !0, P = !!e.fallbackFormat, g = !!e.unresolving, L = le(e.postTranslation) ? e.postTranslation : null, d = X(e.processor) ? e.processor : null, m = pe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, E = !!e.escapeParameter, b = le(e.messageCompiler) ? e.messageCompiler : rl;
  process.env.NODE_ENV !== "production" && le(e.messageCompiler) && Pm(Bt(Me.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const T = le(e.messageResolver) ? e.messageResolver : sl || Yp, x = le(e.localeFallbacker) ? e.localeFallbacker : al || Mp, _ = Z(e.fallbackContext) ? e.fallbackContext : void 0, D = e, B = Z(D.__datetimeFormatters) ? D.__datetimeFormatters : /* @__PURE__ */ new Map(), U = Z(D.__numberFormatters) ? D.__numberFormatters : /* @__PURE__ */ new Map(), H = Z(D.__meta) ? D.__meta : {};
  Ms++;
  const z = {
    version: n,
    cid: Ms,
    locale: o,
    fallbackLocale: s,
    messages: a,
    modifiers: w,
    pluralRules: k,
    missing: v,
    missingWarn: f,
    fallbackWarn: C,
    fallbackFormat: P,
    unresolving: g,
    postTranslation: L,
    processor: d,
    warnHtmlMessage: m,
    escapeParameter: E,
    messageCompiler: b,
    messageResolver: T,
    localeFallbacker: x,
    fallbackContext: _,
    onWarn: t,
    __meta: H
  };
  return z.datetimeFormats = i, z.numberFormats = l, z.__datetimeFormatters = B, z.__numberFormatters = U, process.env.NODE_ENV !== "production" && (z.__v_emitter = D.__v_emitter != null ? D.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Np(z, n, H), z;
}
const Ho = (e) => ({ [e]: oe() });
function Oo(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function cl(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Yr(e, t, n, o, r) {
  const { missing: s, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, n, t, r);
    return $(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && cl(o, t) && a(Bt(Me.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function hn(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function ul(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function rh(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (ul(e, t[o]))
      return !0;
  return !1;
}
const Bs = typeof Intl < "u", dl = {
  dateTimeFormat: Bs && typeof Intl.DateTimeFormat < "u",
  numberFormat: Bs && typeof Intl.NumberFormat < "u"
};
function Rs(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !dl.dateTimeFormat)
    return s(Bt(Me.CANNOT_FORMAT_DATE)), uo;
  const [l, w, k, v] = Jo(...t), f = pe(k.missingWarn) ? k.missingWarn : e.missingWarn, C = pe(k.fallbackWarn) ? k.fallbackWarn : e.fallbackWarn, P = !!k.part, g = Wr(e, k), L = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    g
  );
  if (!$(l) || l === "")
    return new Intl.DateTimeFormat(g, v).format(w);
  let d = {}, m, E = null, b = g, T = null;
  const x = "datetime format";
  for (let B = 0; B < L.length; B++) {
    if (m = T = L[B], process.env.NODE_ENV !== "production" && g !== m && Oo(C, l) && s(Bt(Me.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: m
    })), process.env.NODE_ENV !== "production" && g !== m) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: x,
        key: l,
        from: b,
        to: T,
        groupId: `${x}:${l}`
      });
    }
    if (d = n[m] || {}, E = d[l], X(E))
      break;
    Yr(e, l, m, f, x), b = T;
  }
  if (!X(E) || !$(m))
    return o ? To : l;
  let _ = `${m}__${l}`;
  Ao(v) || (_ = `${_}__${JSON.stringify(v)}`);
  let D = i.get(_);
  return D || (D = new Intl.DateTimeFormat(m, _e({}, E, v)), i.set(_, D)), P ? D.formatToParts(w) : D.format(w);
}
const fl = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Jo(...e) {
  const [t, n, o, r] = e, s = oe();
  let a = oe(), i;
  if ($(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw wt(Oe.INVALID_ISO_DATE_ARGUMENT);
    const w = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(w);
    try {
      i.toISOString();
    } catch {
      throw wt(Oe.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if ($m(t)) {
    if (isNaN(t.getTime()))
      throw wt(Oe.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Ee(t))
    i = t;
  else
    throw wt(Oe.INVALID_ARGUMENT);
  return $(n) ? s.key = n : X(n) && Object.keys(n).forEach((l) => {
    fl.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), $(o) ? s.locale = o : X(o) && (a = o), X(r) && (a = r), [s.key || "", i, s, a];
}
function Fs(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__datetimeFormatters.has(s) && o.__datetimeFormatters.delete(s);
  }
}
function Us(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !dl.numberFormat)
    return s(Bt(Me.CANNOT_FORMAT_NUMBER)), uo;
  const [l, w, k, v] = Qo(...t), f = pe(k.missingWarn) ? k.missingWarn : e.missingWarn, C = pe(k.fallbackWarn) ? k.fallbackWarn : e.fallbackWarn, P = !!k.part, g = Wr(e, k), L = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    g
  );
  if (!$(l) || l === "")
    return new Intl.NumberFormat(g, v).format(w);
  let d = {}, m, E = null, b = g, T = null;
  const x = "number format";
  for (let B = 0; B < L.length; B++) {
    if (m = T = L[B], process.env.NODE_ENV !== "production" && g !== m && Oo(C, l) && s(Bt(Me.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: m
    })), process.env.NODE_ENV !== "production" && g !== m) {
      const U = e.__v_emitter;
      U && U.emit("fallback", {
        type: x,
        key: l,
        from: b,
        to: T,
        groupId: `${x}:${l}`
      });
    }
    if (d = n[m] || {}, E = d[l], X(E))
      break;
    Yr(e, l, m, f, x), b = T;
  }
  if (!X(E) || !$(m))
    return o ? To : l;
  let _ = `${m}__${l}`;
  Ao(v) || (_ = `${_}__${JSON.stringify(v)}`);
  let D = i.get(_);
  return D || (D = new Intl.NumberFormat(m, _e({}, E, v)), i.set(_, D)), P ? D.formatToParts(w) : D.format(w);
}
const wl = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Qo(...e) {
  const [t, n, o, r] = e, s = oe();
  let a = oe();
  if (!Ee(t))
    throw wt(Oe.INVALID_ARGUMENT);
  const i = t;
  return $(n) ? s.key = n : X(n) && Object.keys(n).forEach((l) => {
    wl.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), $(o) ? s.locale = o : X(o) && (a = o), X(r) && (a = r), [s.key || "", i, s, a];
}
function Vs(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__numberFormatters.has(s) && o.__numberFormatters.delete(s);
  }
}
const sh = (e) => e, ah = (e) => "", ih = "text", lh = (e) => e.length === 0 ? "" : Vr(e), ch = Fm;
function Hs(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function uh(e) {
  const t = Ee(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Ee(e.named.count) || Ee(e.named.n)) ? Ee(e.named.count) ? e.named.count : Ee(e.named.n) ? e.named.n : t : t;
}
function dh(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function fh(e = {}) {
  const t = e.locale, n = uh(e), o = Z(e.pluralRules) && $(t) && le(e.pluralRules[t]) ? e.pluralRules[t] : Hs, r = Z(e.pluralRules) && $(t) && le(e.pluralRules[t]) ? Hs : void 0, s = (d) => d[o(n, d.length, r)], a = e.list || [], i = (d) => a[d], l = e.named || oe();
  Ee(e.pluralIndex) && dh(n, l);
  const w = (d) => l[d];
  function k(d, m) {
    const E = le(e.messages) ? e.messages(d, !!m) : Z(e.messages) ? e.messages[d] : !1;
    return E || (e.parent ? e.parent.message(d) : ah);
  }
  const v = (d) => e.modifiers ? e.modifiers[d] : sh, f = X(e.processor) && le(e.processor.normalize) ? e.processor.normalize : lh, C = X(e.processor) && le(e.processor.interpolate) ? e.processor.interpolate : ch, P = X(e.processor) && $(e.processor.type) ? e.processor.type : ih, L = {
    list: i,
    named: w,
    plural: s,
    linked: (d, ...m) => {
      const [E, b] = m;
      let T = "text", x = "";
      m.length === 1 ? Z(E) ? (x = E.modifier || x, T = E.type || T) : $(E) && (x = E || x) : m.length === 2 && ($(E) && (x = E || x), $(b) && (T = b || T));
      const _ = k(d, !0)(L), D = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        T === "vnode" && he(_) && x ? _[0] : _
      );
      return x ? v(x)(D, T) : D;
    },
    message: k,
    type: P,
    interpolate: C,
    normalize: f,
    values: _e(oe(), a, l)
  };
  return L;
}
const js = () => "", ze = (e) => le(e);
function Ws(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: r, messageCompiler: s, fallbackLocale: a, messages: i } = e, [l, w] = er(...t), k = pe(w.missingWarn) ? w.missingWarn : e.missingWarn, v = pe(w.fallbackWarn) ? w.fallbackWarn : e.fallbackWarn, f = pe(w.escapeParameter) ? w.escapeParameter : e.escapeParameter, C = !!w.resolvedMessage, P = $(w.default) || pe(w.default) ? pe(w.default) ? s ? l : () => l : w.default : n ? s ? l : () => l : null, g = n || P != null && ($(P) || le(P)), L = Wr(e, w);
  f && wh(w);
  let [d, m, E] = C ? [
    l,
    L,
    i[L] || oe()
  ] : ml(e, l, L, a, v, k), b = d, T = l;
  if (!C && !($(b) || Qe(b) || ze(b)) && g && (b = P, T = b), !C && (!($(b) || Qe(b) || ze(b)) || !$(m)))
    return r ? To : l;
  if (process.env.NODE_ENV !== "production" && $(b) && e.messageCompiler == null)
    return ct(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let x = !1;
  const _ = () => {
    x = !0;
  }, D = ze(b) ? b : pl(e, l, m, b, T, _);
  if (x)
    return b;
  const B = gh(e, m, E, w), U = fh(B), H = mh(e, D, U);
  let z = o ? o(H, l) : H;
  if (f && $(z) && (z = Mm(z)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const ue = {
      timestamp: Date.now(),
      key: $(l) ? l : ze(b) ? b.key : "",
      locale: m || (ze(b) ? b.locale : ""),
      format: $(b) ? b : ze(b) ? b.source : "",
      message: z
    };
    ue.meta = _e({}, e.__meta, /* @__PURE__ */ th() || {}), Ip(ue);
  }
  return z;
}
function wh(e) {
  he(e.list) ? e.list = e.list.map((t) => $(t) ? Cs(t) : t) : Z(e.named) && Object.keys(e.named).forEach((t) => {
    $(e.named[t]) && (e.named[t] = Cs(e.named[t]));
  });
}
function ml(e, t, n, o, r, s) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: w } = e, k = w(e, o, n);
  let v = oe(), f, C = null, P = n, g = null;
  const L = "translate";
  for (let d = 0; d < k.length; d++) {
    if (f = g = k[d], process.env.NODE_ENV !== "production" && n !== f && !ul(n, f) && Oo(r, t) && i(Bt(Me.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: f
    })), process.env.NODE_ENV !== "production" && n !== f) {
      const T = e.__v_emitter;
      T && T.emit("fallback", {
        type: L,
        key: t,
        from: P,
        to: g,
        groupId: `${L}:${t}`
      });
    }
    v = a[f] || oe();
    let m = null, E, b;
    if (process.env.NODE_ENV !== "production" && ht && (m = window.performance.now(), E = "intlify-message-resolve-start", b = "intlify-message-resolve-end", Fe && Fe(E)), (C = l(v, t)) === null && (C = v[t]), process.env.NODE_ENV !== "production" && ht) {
      const T = window.performance.now(), x = e.__v_emitter;
      x && m && C && x.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: C,
        time: T - m,
        groupId: `${L}:${t}`
      }), E && b && Fe && Mt && (Fe(b), Mt("intlify message resolve", E, b));
    }
    if ($(C) || Qe(C) || ze(C))
      break;
    if (!rh(f, k)) {
      const T = Yr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        f,
        s,
        L
      );
      T !== t && (C = T);
    }
    P = g;
  }
  return [C, f, v];
}
function pl(e, t, n, o, r, s) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (ze(o)) {
    const f = o;
    return f.locale = f.locale || n, f.key = f.key || t, f;
  }
  if (a == null) {
    const f = () => o;
    return f.locale = n, f.key = t, f;
  }
  let l = null, w, k;
  process.env.NODE_ENV !== "production" && ht && (l = window.performance.now(), w = "intlify-message-compilation-start", k = "intlify-message-compilation-end", Fe && Fe(w));
  const v = a(o, ph(e, n, r, o, i, s));
  if (process.env.NODE_ENV !== "production" && ht) {
    const f = window.performance.now(), C = e.__v_emitter;
    C && l && C.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: f - l,
      groupId: `translate:${t}`
    }), w && k && Fe && Mt && (Fe(k), Mt("intlify message compilation", w, k));
  }
  return v.locale = n, v.key = t, v.source = o, v;
}
function mh(e, t, n) {
  let o = null, r, s;
  process.env.NODE_ENV !== "production" && ht && (o = window.performance.now(), r = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", Fe && Fe(r));
  const a = t(n);
  if (process.env.NODE_ENV !== "production" && ht) {
    const i = window.performance.now(), l = e.__v_emitter;
    l && o && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: i - o,
      groupId: `translate:${t.key}`
    }), r && s && Fe && Mt && (Fe(s), Mt("intlify message evaluation", r, s));
  }
  return a;
}
function er(...e) {
  const [t, n, o] = e, r = oe();
  if (!$(t) && !Ee(t) && !ze(t) && !Qe(t))
    throw wt(Oe.INVALID_ARGUMENT);
  const s = Ee(t) ? String(t) : (ze(t), t);
  return Ee(n) ? r.plural = n : $(n) ? r.default = n : X(n) && !Ao(n) ? r.named = n : he(n) && (r.list = n), Ee(o) ? r.plural = o : $(o) ? r.default = o : X(o) && _e(r, o), [s, r];
}
function ph(e, t, n, o, r, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: r,
    onError: (a) => {
      if (s && s(a), process.env.NODE_ENV !== "production") {
        const i = hh(o), l = `Message compilation error: ${a.message}`, w = a.location && i && Um(i, a.location.start.offset, a.location.end.offset), k = e.__v_emitter;
        k && i && k.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(w ? `${l}
${w}` : l);
      } else
        throw a;
    },
    onCacheKey: (a) => Im(t, n, a)
  };
}
function hh(e) {
  if ($(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function gh(e, t, n, o) {
  const { modifiers: r, pluralRules: s, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: w, fallbackContext: k } = e, f = {
    locale: t,
    modifiers: r,
    pluralRules: s,
    messages: (C, P) => {
      let g = a(n, C);
      if (g == null && (k || P)) {
        const [, , L] = ml(
          k || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          C,
          t,
          i,
          l,
          w
        );
        g = a(L, C);
      }
      if ($(g) || Qe(g)) {
        let L = !1;
        const m = pl(e, C, t, g, C, () => {
          L = !0;
        });
        return L ? js : m;
      } else return ze(g) ? g : js;
    }
  };
  return e.processor && (f.processor = e.processor), o.list && (f.list = o.list), o.named && (f.named = o.named), Ee(o.plural) && (f.pluralIndex = o.plural), f;
}
gp();
/*!
  * vue-i18n v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const bh = "11.2.8";
function vh() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Nt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Nt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Le = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: $p,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function _n(e, ...t) {
  return ln(e, null, process.env.NODE_ENV !== "production" ? { messages: yh, args: t } : void 0);
}
const yh = {
  [Le.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Le.INVALID_ARGUMENT]: "Invalid argument",
  [Le.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Le.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Le.UNEXPECTED_ERROR]: "Unexpected error",
  [Le.REQUIRED_VALUE]: "Required in value: {0}",
  [Le.INVALID_VALUE]: "Invalid value",
  [Le.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Le.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Le.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Le.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, tr = /* @__PURE__ */ gt("__translateVNode"), nr = /* @__PURE__ */ gt("__datetimeParts"), or = /* @__PURE__ */ gt("__numberParts"), rr = /* @__PURE__ */ gt("__enableEmitter"), sr = /* @__PURE__ */ gt("__disableEmitter"), Eh = gt("__setPluralRules"), hl = /* @__PURE__ */ gt("__injectWithOption"), ar = /* @__PURE__ */ gt("__dispose"), at = {
  FALLBACK_TO_ROOT: zp,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, _h = {
  [at.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [at.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [at.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [at.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [at.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [at.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function fo(e, ...t) {
  return Lo(_h[e], ...t);
}
function kn(e) {
  if (!Z(e) || Qe(e))
    return e;
  for (const t in e)
    if (Je(e, t))
      if (!t.includes("."))
        Z(e[t]) && kn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let r = e, s = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in r || (r[n[a]] = oe()), !Z(r[n[a]])) {
            process.env.NODE_ENV !== "production" && ct(fo(at.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), s = !0;
            break;
          }
          r = r[n[a]];
        }
        if (s || (Qe(r) ? nl.includes(n[o]) || delete e[t] : (r[n[o]] = e[t], delete e[t])), !Qe(r)) {
          const a = r[n[o]];
          Z(a) && kn(a);
        }
      }
  return e;
}
function gl(e, t) {
  const { messages: n, __i18n: o, messageResolver: r, flatJson: s } = t, a = X(n) ? n : he(o) ? oe() : { [e]: oe() };
  if (he(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: w } = i;
      l ? (a[l] = a[l] || oe(), jn(w, a[l])) : jn(w, a);
    } else
      $(i) && jn(JSON.parse(i), a);
  }), r == null && s)
    for (const i in a)
      Je(a, i) && kn(a[i]);
  return a;
}
function bl(e) {
  return e.type;
}
function kh(e, t, n) {
  let o = Z(t.messages) ? t.messages : oe();
  "__i18nGlobal" in n && (o = gl(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(o);
  r.length && r.forEach((s) => {
    e.mergeLocaleMessage(s, o[s]);
  });
  {
    if (Z(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (Z(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function Ys(e) {
  return Qs(Ll, null, e, 0);
}
function qr() {
  const e = "currentInstance";
  return e in No ? No[e] : No.getCurrentInstance();
}
const qs = "__INTLIFY_META__", zs = () => [], Ch = () => !1;
let Ks = 0;
function Gs(e) {
  return (t, n, o, r) => e(n, o, qr() || void 0, r);
}
const Lh = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = qr();
  let t = null;
  return e && (t = bl(e)[qs]) ? { [qs]: t } : null;
};
function Ah(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, r = e.flatJson, s = ht ? gn : kl;
  let a = pe(e.inheritLocale) ? e.inheritLocale : !0;
  const i = s(
    // prettier-ignore
    t && a ? t.locale.value : $(e.locale) ? e.locale : co
  ), l = s(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : $(e.fallbackLocale) || he(e.fallbackLocale) || X(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), w = s(gl(i.value, e)), k = s(X(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), v = s(X(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let f = t ? t.missingWarn : pe(e.missingWarn) || lo(e.missingWarn) ? e.missingWarn : !0, C = t ? t.fallbackWarn : pe(e.fallbackWarn) || lo(e.fallbackWarn) ? e.fallbackWarn : !0, P = t ? t.fallbackRoot : pe(e.fallbackRoot) ? e.fallbackRoot : !0, g = !!e.fallbackFormat, L = le(e.missing) ? e.missing : null, d = le(e.missing) ? Gs(e.missing) : null, m = le(e.postTranslation) ? e.postTranslation : null, E = t ? t.warnHtmlMessage : pe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, b = !!e.escapeParameter;
  const T = t ? t.modifiers : X(e.modifiers) ? e.modifiers : {};
  let x = e.pluralRules || t && t.pluralRules, _;
  _ = (() => {
    o && Ds(null);
    const y = {
      version: bh,
      locale: i.value,
      fallbackLocale: l.value,
      messages: w.value,
      modifiers: T,
      pluralRules: x,
      missing: d === null ? void 0 : d,
      missingWarn: f,
      fallbackWarn: C,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: m === null ? void 0 : m,
      warnHtmlMessage: E,
      escapeParameter: b,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    y.datetimeFormats = k.value, y.numberFormats = v.value, y.__datetimeFormatters = X(_) ? _.__datetimeFormatters : void 0, y.__numberFormatters = X(_) ? _.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (y.__v_emitter = X(_) ? _.__v_emitter : void 0);
    const O = oh(y);
    return o && Ds(O), O;
  })(), hn(_, i.value, l.value);
  function B() {
    return [
      i.value,
      l.value,
      w.value,
      k.value,
      v.value
    ];
  }
  const U = dn({
    get: () => i.value,
    set: (y) => {
      _.locale = y, i.value = y;
    }
  }), H = dn({
    get: () => l.value,
    set: (y) => {
      _.fallbackLocale = y, l.value = y, hn(_, i.value, y);
    }
  }), z = dn(() => w.value), ue = /* @__PURE__ */ dn(() => k.value), j = /* @__PURE__ */ dn(() => v.value);
  function I() {
    return le(m) ? m : null;
  }
  function N(y) {
    m = y, _.postTranslation = y;
  }
  function F() {
    return L;
  }
  function S(y) {
    y !== null && (d = Gs(y)), L = y, _.missing = d;
  }
  function q(y, O) {
    return y !== "translate" || !O.resolvedMessage;
  }
  const W = (y, O, Q, fe, At, Mn) => {
    B();
    let Ht;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (_.fallbackContext = t ? nh() : void 0), Ht = y(_);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (_.fallbackContext = void 0);
    }
    if (Q !== "translate exists" && // for not `te` (e.g `t`)
    Ee(Ht) && Ht === To || Q === "translate exists" && !Ht) {
      const [Tt, El] = O();
      if (process.env.NODE_ENV !== "production" && t && $(Tt) && q(Q, El) && (P && (Oo(C, Tt) || cl(f, Tt)) && ct(fo(at.FALLBACK_TO_ROOT, {
        key: Tt,
        type: Q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Kr } = _;
        Kr && P && Kr.emit("fallback", {
          type: Q,
          key: Tt,
          to: "global",
          groupId: `${Q}:${Tt}`
        });
      }
      return t && P ? fe(t) : At(Tt);
    } else {
      if (Mn(Ht))
        return Ht;
      throw _n(Le.UNEXPECTED_RETURN_TYPE);
    }
  };
  function K(...y) {
    return W((O) => Reflect.apply(Ws, null, [O, ...y]), () => er(...y), "translate", (O) => Reflect.apply(O.t, O, [...y]), (O) => O, (O) => $(O));
  }
  function ae(...y) {
    const [O, Q, fe] = y;
    if (fe && !Z(fe))
      throw _n(Le.INVALID_ARGUMENT);
    return K(O, Q, _e({ resolvedMessage: !0 }, fe || {}));
  }
  function ce(...y) {
    return W((O) => Reflect.apply(Rs, null, [O, ...y]), () => Jo(...y), "datetime format", (O) => Reflect.apply(O.d, O, [...y]), () => uo, (O) => $(O) || he(O));
  }
  function ve(...y) {
    return W((O) => Reflect.apply(Us, null, [O, ...y]), () => Qo(...y), "number format", (O) => Reflect.apply(O.n, O, [...y]), () => uo, (O) => $(O) || he(O));
  }
  function Ae(y) {
    return y.map((O) => $(O) || Ee(O) || pe(O) ? Ys(String(O)) : O);
  }
  const Xe = {
    normalize: Ae,
    interpolate: (y) => y,
    type: "vnode"
  };
  function et(...y) {
    return W((O) => {
      let Q;
      const fe = O;
      try {
        fe.processor = Xe, Q = Reflect.apply(Ws, null, [fe, ...y]);
      } finally {
        fe.processor = null;
      }
      return Q;
    }, () => er(...y), "translate", (O) => O[tr](...y), (O) => [Ys(O)], (O) => he(O));
  }
  function Ze(...y) {
    return W((O) => Reflect.apply(Us, null, [O, ...y]), () => Qo(...y), "number format", (O) => O[or](...y), zs, (O) => $(O) || he(O));
  }
  function ye(...y) {
    return W((O) => Reflect.apply(Rs, null, [O, ...y]), () => Jo(...y), "datetime format", (O) => O[nr](...y), zs, (O) => $(O) || he(O));
  }
  function qe(y) {
    x = y, _.pluralRules = x;
  }
  function dt(y, O) {
    return W(() => {
      if (!y)
        return !1;
      const Q = $(O) ? O : i.value, fe = Lt(Q), At = _.messageResolver(fe, y);
      return Qe(At) || ze(At) || $(At);
    }, () => [y], "translate exists", (Q) => Reflect.apply(Q.te, Q, [y, O]), Ch, (Q) => pe(Q));
  }
  function tt(y) {
    let O = null;
    const Q = ol(_, l.value, i.value);
    for (let fe = 0; fe < Q.length; fe++) {
      const At = w.value[Q[fe]] || {}, Mn = _.messageResolver(At, y);
      if (Mn != null) {
        O = Mn;
        break;
      }
    }
    return O;
  }
  function cn(y) {
    const O = tt(y);
    return O ?? (t ? t.tm(y) || {} : {});
  }
  function Lt(y) {
    return w.value[y] || {};
  }
  function un(y, O) {
    if (r) {
      const Q = { [y]: O };
      for (const fe in Q)
        Je(Q, fe) && kn(Q[fe]);
      O = Q[y];
    }
    w.value[y] = O, _.messages = w.value;
  }
  function Po(y, O) {
    w.value[y] = w.value[y] || {};
    const Q = { [y]: O };
    if (r)
      for (const fe in Q)
        Je(Q, fe) && kn(Q[fe]);
    O = Q[y], jn(O, w.value[y]), _.messages = w.value;
  }
  function c(y) {
    return k.value[y] || {};
  }
  function u(y, O) {
    k.value[y] = O, _.datetimeFormats = k.value, Fs(_, y, O);
  }
  function A(y, O) {
    k.value[y] = _e(k.value[y] || {}, O), _.datetimeFormats = k.value, Fs(_, y, O);
  }
  function M(y) {
    return v.value[y] || {};
  }
  function ie(y, O) {
    v.value[y] = O, _.numberFormats = v.value, Vs(_, y, O);
  }
  function de(y, O) {
    v.value[y] = _e(v.value[y] || {}, O), _.numberFormats = v.value, Vs(_, y, O);
  }
  Ks++, t && ht && (Gr(t.locale, (y) => {
    a && (i.value = y, _.locale = y, hn(_, i.value, l.value));
  }), Gr(t.fallbackLocale, (y) => {
    a && (l.value = y, _.fallbackLocale = y, hn(_, i.value, l.value));
  }));
  const G = {
    id: Ks,
    locale: U,
    fallbackLocale: H,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(y) {
      a = y, y && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, hn(_, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(w.value).sort();
    },
    messages: z,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return x || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(y) {
      f = y, _.missingWarn = f;
    },
    get fallbackWarn() {
      return C;
    },
    set fallbackWarn(y) {
      C = y, _.fallbackWarn = C;
    },
    get fallbackRoot() {
      return P;
    },
    set fallbackRoot(y) {
      P = y;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(y) {
      g = y, _.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return E;
    },
    set warnHtmlMessage(y) {
      E = y, _.warnHtmlMessage = y;
    },
    get escapeParameter() {
      return b;
    },
    set escapeParameter(y) {
      b = y, _.escapeParameter = y;
    },
    t: K,
    getLocaleMessage: Lt,
    setLocaleMessage: un,
    mergeLocaleMessage: Po,
    getPostTranslationHandler: I,
    setPostTranslationHandler: N,
    getMissingHandler: F,
    setMissingHandler: S,
    [Eh]: qe
  };
  return G.datetimeFormats = ue, G.numberFormats = j, G.rt = ae, G.te = dt, G.tm = cn, G.d = ce, G.n = ve, G.getDateTimeFormat = c, G.setDateTimeFormat = u, G.mergeDateTimeFormat = A, G.getNumberFormat = M, G.setNumberFormat = ie, G.mergeNumberFormat = de, G[hl] = n, G[tr] = et, G[nr] = ye, G[or] = Ze, process.env.NODE_ENV !== "production" && (G[rr] = (y) => {
    _.__v_emitter = y;
  }, G[sr] = () => {
    _.__v_emitter = void 0;
  }), G;
}
function Xs(e, t) {
}
const zr = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Th({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, r) => [
    ...o,
    // prettier-ignore
    ...r.type === ea ? r.children : [r]
  ], []) : t.reduce((n, o) => {
    const r = e[o];
    return r && (n[o] = r()), n;
  }, oe());
}
function vl() {
  return ea;
}
_e({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Ee(e) || !isNaN(e)
  }
}, zr);
function Oh(e) {
  return he(e) && !$(e[0]);
}
function yl(e, t, n, o) {
  const { slots: r, attrs: s } = t;
  return () => {
    const a = { part: !0 };
    let i = oe();
    e.locale && (a.locale = e.locale), $(e.format) ? a.key = e.format : Z(e.format) && ($(e.format.key) && (a.key = e.format.key), i = Object.keys(e.format).reduce((f, C) => n.includes(C) ? _e(oe(), f, { [C]: e.format[C] }) : f, oe()));
    const l = o(e.value, a, i);
    let w = [a.key];
    he(l) ? w = l.map((f, C) => {
      const P = r[f.type], g = P ? P({ [f.type]: f.value, index: C, parts: l }) : [f.value];
      return Oh(g) && (g[0].key = `${f.type}-${C}`), g;
    }) : $(l) && (w = [l]);
    const k = _e(oe(), s), v = $(e.tag) || Z(e.tag) ? e.tag : vl();
    return Js(v, k, w);
  };
}
_e({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, zr);
const xh = /* @__PURE__ */ gt("global-vue-i18n");
function xo(e = {}) {
  const t = qr();
  if (t == null)
    throw _n(Le.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw _n(Le.NOT_INSTALLED);
  const n = Ph(t), o = Ih(n), r = bl(t), s = Nh(e, r);
  if (s === "global")
    return kh(o, e, r), o;
  if (s === "parent") {
    let l = Sh(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && ct(fo(at.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = _e({}, e);
    "__i18n" in r && (l.__i18n = r.__i18n), o && (l.__root = o), i = Ah(l), a.__composerExtend && (i[ar] = a.__composerExtend(i)), Dh(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && s === "local" && ct(fo(at.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function Ph(e) {
  const t = _l(e.isCE ? xh : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw _n(e.isCE ? Le.NOT_INSTALLED_WITH_PROVIDE : Le.UNEXPECTED_ERROR);
  return t;
}
function Nh(e, t) {
  return Ao(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Ih(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Sh(e, t, n = !1) {
  let o = null;
  const r = t.root;
  let s = $h(t, n);
  for (; s != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(s);
      i != null && (o = i.__composer, n && o && !o[hl] && (o = null));
    }
    if (o != null || r === s)
      break;
    s = s.parent;
  }
  return o;
}
function $h(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Dh(e, t, n) {
  let o = null;
  Zs(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Vm();
      const r = n;
      r[rr] && r[rr](o), o.on("*", Xs);
    }
  }, t), Cl(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", Xs), r[sr] && r[sr](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const s = r[ar];
    s && (s(), delete r[ar]);
  }, t);
}
_e({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, zr);
vh();
Zp(xp);
Jp(qp);
Qp(ol);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Nt();
  e.__INTLIFY__ = !0, Pp(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Mh() {
  const e = /iPad|iPhone|iPod/.test(navigator.userAgent), t = gn(
    window.matchMedia("(display-mode: standalone)").matches || navigator.standalone
  );
  return {
    isIOS: e,
    isStandalone: t
  };
}
const Bh = { class: "notification-container" }, Rh = {
  key: 0,
  class: "state-card loading"
}, Fh = {
  key: 1,
  class: "state-card"
}, Uh = {
  key: 0,
  class: "content"
}, Vh = {
  key: 1,
  class: "content"
}, Hh = /* @__PURE__ */ wo({
  __name: "NotificationManager",
  props: {
    notificationApi: {},
    vapidKey: {},
    merchantId: {}
  },
  setup(e) {
    const { t } = xo(), n = e, { initNotificationListener: o, requestPermission: r, loading: s, isSubscribed: a } = xm(n.notificationApi), { isIOS: i, isStandalone: l } = Mh(), w = {
      refresh: "🔄",
      blocked: "🚫",
      bell: "🔔"
    }, k = async () => {
      try {
        await o(n.vapidKey, n.merchantId, t);
      } catch (f) {
        Ne.error("Failed to initialize notifications", f);
      }
    }, v = async () => {
      try {
        await r() && await k();
      } catch (f) {
        Ne.error("Error in handleEnableNotifications", f);
      }
    };
    return Zs(() => {
      typeof Notification < "u" && Notification.permission === "granted" ? k() : a.value = !1;
    }), (f, C) => (wn(), fn("div", Bh, [
      Qs(Al, {
        name: "fade",
        mode: "out-in"
      }, {
        default: Tl(() => [
          mn(s) ? (wn(), fn("div", Rh, [
            C[0] || (C[0] = Bn("div", { class: "spinner" }, null, -1)),
            Bn("span", {
              class: xl([{ "animate-spin": mn(s) }, "text-xl"])
            }, Io(w.refresh), 3)
          ])) : mn(a) ? Ol("", !0) : (wn(), fn("div", Fh, [
            mn(i) && !mn(l) ? (wn(), fn("div", Uh, [
              Bn("p", null, Io(w.blocked), 1)
            ])) : (wn(), fn("div", Vh, [
              Bn("button", {
                onClick: v,
                class: "enable-btn"
              }, Io(w.bell), 1)
            ]))
          ]))
        ]),
        _: 1
      })
    ]));
  }
}), jh = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, zh = /* @__PURE__ */ jh(Hh, [["__scopeId", "data-v-563e236b"]]);
export {
  zh as NotificationManager
};
